import { html, TemplateResult } from 'lit';

export class WelcomeImage {
  static getWelcomeSvg(): TemplateResult {
    return html`
      <svg fill="none" viewBox="0 0 929 593" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m152.03 89.951 16.312-19.45 10.823 29.268-27.135-9.8179z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m597.5 253.37 3.441-18.609 19.808 9.302-23.249 9.307z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m80.092 393.24-8.4802-14.918 20.405-2.984-11.925 17.902z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m627.68 142.16 13.416-12.772-15.811-4.685 2.395 17.457z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m522.8 91.478-0.968-19.773-15.488 6.8381 16.456 12.935z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m501.92 287.94 12.633-17.175 19.052 28.797-31.685-11.622z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m565.45 187.72 20.138-8.514"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m464.61 237.83 8.117 0.245"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m510.84 374.64-3.185 23.45"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m685.22 225.64 27.892-18.223"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m521.83 201.55-48.248-13.461 37.254 36.51 10.994-23.049z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m707.01 333-7.894-40.131"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m117.46 243.62-2.285-10.94 15.841 4.788-13.556 6.152z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m40.728 186.53 18.533 7.224"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m809.35 113.18 16.6-5.952-6.255 20.925-10.345-14.973z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m848.61 257.58-10.308 13.858"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m854.3 134.08 4.268-18.765"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m65.76 277.82 12.173 1.768"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m128.04 208.27 27.551-9.229"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m11.853 405.66 6.2665 20.362"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m866.98 290.37-13.182 20.073-3.585-14.091 16.767-5.982z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m27.531 154.11 15.718-14.892 4.8908 13.773-20.609 1.119z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m166.96 161.53-25.822 19.228-26.32-15.329 52.142-3.899zl-45.671-42.548-6.471 46.447-55.553 28.327"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m40.728 186.53-24.106 4.729-15.622-4.729"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m200.89 324-51.493-34.379 47.692 82.23 3.801-47.851zl-64.556 52.203 13.063-86.582-58.946 38.208 45.883 48.374-44.314-0.868-1.5685-47.506-48.89-24.458-30.814 4.188-9.7446-10.325"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m90.448 327.83-18.421-23.087-30.469-1.371-22.912-21.263-7.9018 25.451-9.7446 4.785"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m255.32 397.07-39.813 31.214 53.766-20.547"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m215.5 428.28-24.221 35.02"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m370.1 116.2 26.279-26.562 35.667-11.723"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m438.68 208.32 34.904-20.236 24.335 54.815 12.919-18.305 4.895 4.529 6.099-27.578 15.997 14.966 27.621-28.79 4.709 24.472-32.33 4.318 46.127 28.301 4.502-30.284-50.629 1.983"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m588.46 214.53 53.959-32.259 31.284 53.977-32.197 6.653 0.913-60.63-41.478 52.487-12.481-20.228zl53.046 28.371 41.352-106.31 48.074 77.702 28.578-14.103 26.008 13.484-54.586 0.619 13.13 56.987 41.456-57.606 31.892 23.345-28.451-91.637-3.441 68.292 70.418-1.776-66.977-66.516 65.35-11.3 1.627 77.816 46.617-58.18-48.244-19.636 50.25 69.796-2.006-50.16-12.251 83.068-34.366-24.888 48.623-8.02 14.821-23.876 8.625 2.269"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m673.7 236.25 9.155-99.657 106.1 8.791-29.449 54.808-76.652-63.599"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m788.95 145.38 5.436-26.173"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m407.49 320.69 18.588 10.195 28.121 2.762 47.726-45.71-75.847 42.948 84.757 43.749-56.636-40.987 73.063 7.872-25.337-53.582 8.91 86.697 16.427-33.115 6.348-41.959 50.343-53.121-69.395 24.324"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m533.61 299.56 67.326 24.599 0.223-49.979-28.656 23.479 28.433 26.5 73.797-49.979h-73.574l97.954 18.683-24.38-18.683-1.035-37.934"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m699.11 292.86 44.944-21.585 64.416 23.89 8.932-58.151-73.348 34.261 1.246 24.643"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m904.55 203.88-13.964 34.572 9.556 12.998"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m377.9 371.86 41.763 1.679-23.194-10.047-18.569 8.368zl31.774 47.878 9.358-27.145 0.631-19.054-9.989 46.199 29.003 15.718"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-miterlimit="10"
          stroke-opacity="0.8"
          stroke-width=".25"
        />
        <path
          d="m761.17 199.89c0.164 0.919-0.452 1.797-1.372 1.96-0.919 0.164-1.798-0.452-1.961-1.371s0.452-1.797 1.372-1.96c0.92-0.164 1.798 0.452 1.961 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m60.925 193.46c0.1632 0.919-0.4523 1.797-1.3719 1.96s-1.7984-0.452-1.9616-1.371c-0.1631-0.919 0.4524-1.797 1.372-1.961 0.9196-0.163 1.7984 0.453 1.9615 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m845.05 331.82c0.164 0.919-0.452 1.798-1.372 1.961-0.919 0.163-1.798-0.452-1.961-1.371-0.163-0.92 0.452-1.798 1.372-1.961 0.919-0.163 1.798 0.452 1.961 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m288.64 429.5c0.163 0.92-0.452 1.798-1.372 1.961-0.919 0.163-1.798-0.452-1.961-1.371-0.164-0.919 0.452-1.798 1.372-1.961 0.919-0.163 1.798 0.452 1.961 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m202.24 90.281c-0.564 0.7449-1.625 0.8932-2.37 0.3298-0.745-0.5633-0.894-1.6233-0.33-2.3683 0.564-0.7449 1.624-0.8932 2.37-0.3298 0.745 0.5633 0.893 1.6233 0.33 2.3683z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m206.08 69.785c-0.564 0.7449-1.624 0.8932-2.369 0.3298-0.746-0.5633-0.894-1.6233-0.33-2.3683 0.563-0.7449 1.624-0.8932 2.369-0.3298 0.745 0.5633 0.894 1.6233 0.33 2.3683z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m904.24 153.85c-0.074 0.93-0.893 1.623-1.824 1.549s-1.624-0.893-1.55-1.823c0.078-0.931 0.894-1.624 1.825-1.55 0.93 0.074 1.624 0.894 1.549 1.824z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m43.223 303.08c0.1631 0.919-0.4524 1.798-1.372 1.961s-1.7984-0.452-1.9615-1.371c-0.1632-0.92 0.4524-1.798 1.372-1.961 0.9195-0.163 1.7983 0.452 1.9615 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m40.197 402.14c0.1632 0.919-0.4523 1.797-1.3719 1.96s-1.7984-0.452-1.9615-1.371c-0.1632-0.919 0.4523-1.798 1.3719-1.961s1.7984 0.452 1.9615 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m105.54 403.75c0.163 0.919-0.452 1.797-1.372 1.96s-1.798-0.452-1.962-1.371c-0.163-0.919 0.453-1.798 1.372-1.961 0.92-0.163 1.799 0.453 1.962 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m882.37 111.52c0.164 0.919-0.452 1.797-1.371 1.96-0.92 0.163-1.799-0.452-1.962-1.371s0.452-1.798 1.372-1.961 1.798 0.453 1.961 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m406.74 128.44c0.163 0.919-0.452 1.797-1.372 1.96-0.919 0.163-1.798-0.452-1.961-1.371s0.452-1.797 1.372-1.961c0.919-0.163 1.798 0.453 1.961 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m433.72 77.616c0.164 0.9191-0.452 1.7975-1.372 1.9606-0.919 0.163-1.798-0.4522-1.961-1.3713-0.163-0.9192 0.452-1.7976 1.372-1.9607 0.919-0.163 1.798 0.4522 1.961 1.3714z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m365.67 469c0.163 0.919-0.453 1.798-1.372 1.961-0.92 0.163-1.799-0.452-1.962-1.371-0.163-0.92 0.453-1.798 1.372-1.961 0.92-0.163 1.799 0.452 1.962 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m60.925 365.24c0.1632 0.919-0.4523 1.798-1.3719 1.961s-1.7984-0.452-1.9616-1.372c-0.1631-0.919 0.4524-1.797 1.372-1.96s1.7984 0.452 1.9615 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m468.54 325.32c0.164 0.919-0.452 1.797-1.371 1.96-0.92 0.163-1.799-0.452-1.962-1.371s0.452-1.797 1.372-1.961c0.92-0.163 1.798 0.453 1.961 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m523.28 249.1c-0.59 0.263-1.28 0-1.543-0.586-0.263-0.589 0-1.279 0.586-1.542s1.279 0 1.542 0.586c0.264 0.589 0 1.279-0.585 1.542z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m459.69 136.3c0.163 0.919-0.452 1.798-1.372 1.961-0.919 0.163-1.798-0.452-1.961-1.371-0.164-0.92 0.452-1.798 1.372-1.961 0.919-0.163 1.798 0.452 1.961 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m391.48 198.26c0.163 0.919-0.453 1.797-1.372 1.96-0.92 0.163-1.799-0.452-1.962-1.371s0.453-1.798 1.372-1.961c0.92-0.163 1.799 0.453 1.962 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m411.34 419.44c0.164 0.919-0.452 1.798-1.371 1.961-0.92 0.163-1.799-0.453-1.962-1.372s0.452-1.797 1.372-1.96c0.919-0.163 1.798 0.452 1.961 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m440.35 435.16c0.163 0.919-0.452 1.798-1.372 1.961-0.919 0.163-1.798-0.452-1.961-1.371-0.163-0.92 0.452-1.798 1.372-1.961 0.919-0.163 1.798 0.452 1.961 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m511.32 225.66c-0.589 0.263-1.279 0-1.542-0.586-0.263-0.585 0-1.279 0.586-1.542s1.279 0 1.542 0.586c0.263 0.585 0 1.279-0.586 1.542z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m197.03 115.91c0.163 0.919-0.452 1.797-1.372 1.96-0.919 0.163-1.798-0.452-1.961-1.371s0.452-1.798 1.372-1.961c0.919-0.163 1.798 0.452 1.961 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m90.374 226.17c0.1632 0.919-0.4524 1.797-1.3719 1.96-0.9196 0.164-1.7984-0.452-1.9616-1.371-0.1631-0.919 0.4524-1.797 1.372-1.96 0.9196-0.164 1.7984 0.452 1.9615 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m460.44 201.36c0.782 0.508 1.008 1.556 0.5 2.338s-1.557 1.009-2.34 0.501c-0.782-0.508-1.008-1.557-0.5-2.339s1.557-1.008 2.34-0.5z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m92.113 327.54c0.1632 0.919-0.4524 1.797-1.3719 1.96-0.9196 0.164-1.7984-0.452-1.9616-1.371-0.1631-0.919 0.4524-1.797 1.372-1.96 0.9196-0.164 1.7984 0.452 1.9615 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m719.32 300.53c0.163 0.919-0.452 1.797-1.372 1.96-0.919 0.163-1.798-0.452-1.961-1.371-0.164-0.919 0.452-1.798 1.371-1.961 0.92-0.163 1.799 0.453 1.962 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m788.59 213.13c0.3 1.697-0.835 3.317-2.533 3.613-1.698 0.3-3.319-0.834-3.615-2.531-0.301-1.698 0.834-3.317 2.532-3.614 1.699-0.3 3.319 0.834 3.616 2.532z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m233.02 98.812c0.301 1.6977-0.834 3.3167-2.532 3.6137-1.698 0.3-3.319-0.834-3.615-2.5314-0.301-1.6975 0.834-3.3171 2.532-3.6136 1.698-0.3002 3.319 0.8339 3.615 2.5313z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m530.34 340.98c0.3 1.697-0.835 3.317-2.533 3.613-1.698 0.301-3.318-0.834-3.615-2.531-0.297-1.698 0.834-3.317 2.532-3.614 1.699-0.3 3.319 0.834 3.616 2.532z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m548.93 323.62c0.301 1.698-0.834 3.317-2.532 3.614-1.699 0.296-3.319-0.834-3.616-2.532-0.3-1.697 0.835-3.317 2.533-3.613 1.698-0.3 3.319 0.834 3.615 2.531z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m429.15 330.34c0.3 1.698-0.835 3.318-2.533 3.614-1.698 0.3-3.319-0.834-3.615-2.531-0.297-1.698 0.834-3.317 2.532-3.614 1.699-0.3 3.319 0.834 3.616 2.531z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m600.57 252.82c0.3 1.698-0.834 3.318-2.533 3.614-1.698 0.3-3.318-0.834-3.615-2.531-0.297-1.698 0.834-3.317 2.533-3.614 1.698-0.3 3.318 0.834 3.615 2.531z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m218.58 427.74c0.3 1.697-0.834 3.317-2.532 3.614-1.699 0.3-3.319-0.834-3.616-2.532-0.3-1.697 0.835-3.317 2.533-3.613 1.698-0.301 3.319 0.834 3.615 2.531z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m420.15 393.86c-0.701 0.615-1.773 0.548-2.388-0.156-0.616-0.7-0.549-1.771 0.155-2.387 0.701-0.615 1.773-0.548 2.388 0.156 0.616 0.7 0.549 1.772-0.155 2.387z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m449.81 398.27c-0.701 0.615-1.772 0.548-2.388-0.156-0.615-0.701-0.549-1.772 0.156-2.387 0.701-0.615 1.772-0.548 2.388 0.156 0.615 0.7 0.549 1.771-0.156 2.387z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m398.53 365.83c-1.294 1.138-3.267 1.012-4.405-0.286-1.138-1.293-1.012-3.265 0.285-4.403 1.295-1.137 3.267-1.011 4.406 0.286 1.138 1.293 1.012 3.265-0.286 4.403z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m604.01 234.22c0.3 1.697-0.835 3.317-2.533 3.613-1.698 0.3-3.319-0.834-3.615-2.531-0.301-1.698 0.834-3.317 2.532-3.614 1.699-0.3 3.319 0.834 3.616 2.532z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m158.66 383.23c0.301 1.697-0.834 3.317-2.532 3.613-1.699 0.3-3.319-0.834-3.616-2.531-0.3-1.698 0.835-3.317 2.533-3.614 1.698-0.3 3.319 0.834 3.615 2.532z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m152.47 289.08c0.301 1.697-0.834 3.317-2.532 3.613-1.699 0.301-3.319-0.833-3.616-2.531-0.3-1.697 0.835-3.317 2.533-3.614 1.698-0.3 3.319 0.834 3.615 2.532z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m129.01 312.97c0.301 1.697-0.834 3.317-2.532 3.613-1.698 0.3-3.319-0.834-3.615-2.531-0.301-1.698 0.834-3.317 2.532-3.614 1.698-0.3 3.319 0.834 3.615 2.532z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m30.605 153.56c0.3003 1.697-0.8343 3.317-2.5326 3.613-1.6983 0.297-3.3187-0.834-3.6153-2.531-0.3004-1.697 0.8343-3.317 2.5326-3.614 1.6982-0.3 3.3186 0.834 3.6153 2.532z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m522.72 203.51c-1.083 0.489-2.359 7e-3 -2.848-1.079s-7e-3 -2.357 1.079-2.846c1.087-0.49 2.358-8e-3 2.848 1.078 0.489 1.082 7e-3 2.357-1.079 2.847z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m219.12 112.02c0.163 0.919-0.453 1.797-1.372 1.96-0.92 0.163-1.799-0.452-1.962-1.371s0.453-1.797 1.372-1.961c0.92-0.163 1.799 0.453 1.962 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m257.84 79.699c0.3 1.6975-0.834 3.3171-2.533 3.6136-1.698 0.3002-3.318-0.8339-3.615-2.5314-0.3-1.6974 0.834-3.3171 2.533-3.6136 1.698-0.2965 3.318 0.8339 3.615 2.5314z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m399.46 89.095c0.3 1.6974-0.834 3.3171-2.533 3.6136-1.698 0.3002-3.318-0.8339-3.615-2.5314-0.3-1.6975 0.834-3.3171 2.533-3.6136 1.698-0.2965 3.318 0.8339 3.615 2.5314z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m602.6 323.87c0.163 0.919-0.453 1.798-1.372 1.961-0.92 0.163-1.799-0.453-1.962-1.372s0.452-1.797 1.372-1.96 1.798 0.452 1.962 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m734 213.75c0.301 1.697-0.834 3.317-2.532 3.613-1.699 0.297-3.319-0.834-3.616-2.531-0.3-1.698 0.835-3.317 2.533-3.614 1.698-0.3 3.319 0.834 3.615 2.532z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m422.49 210.28c0.164 0.919-0.452 1.797-1.372 1.96-0.919 0.163-1.798-0.452-1.961-1.371s0.452-1.797 1.372-1.961c0.919-0.163 1.798 0.453 1.961 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m389.64 120.28c0.163 0.919-0.452 1.797-1.372 1.96-0.919 0.163-1.798-0.452-1.961-1.371s0.452-1.798 1.372-1.961c0.919-0.163 1.798 0.452 1.961 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m195.35 78.754c0.163 0.9191-0.452 1.7975-1.372 1.9606-0.919 0.1631-1.798-0.4522-1.961-1.3713-0.163-0.9192 0.452-1.7976 1.372-1.9606 0.919-0.1631 1.798 0.4521 1.961 1.3713z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m455.96 116.28c0.163 0.919-0.452 1.798-1.372 1.961s-1.798-0.452-1.962-1.372c-0.163-0.919 0.453-1.797 1.372-1.96 0.92-0.163 1.799 0.452 1.962 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m484.2 257.7c0.163 0.919-0.453 1.798-1.372 1.961-0.92 0.163-1.799-0.452-1.962-1.371-0.163-0.92 0.453-1.798 1.372-1.961 0.92-0.163 1.799 0.452 1.962 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m458.19 88.98c0.163 0.9191-0.452 1.7975-1.372 1.9606-0.919 0.163-1.798-0.4522-1.961-1.3713-0.164-0.9192 0.452-1.7976 1.371-1.9606 0.92-0.1631 1.799 0.4521 1.962 1.3713z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m124.36 118.44c0.3 1.697-0.835 3.317-2.533 3.613-1.698 0.3-3.319-0.834-3.615-2.531-0.301-1.698 0.834-3.317 2.532-3.614 1.699-0.3 3.319 0.834 3.616 2.532z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m680.97 80.196c0.301 1.6974-0.834 3.3171-2.532 3.6136-1.699 0.2965-3.319-0.8339-3.616-2.5314-0.3-1.6975 0.835-3.3171 2.533-3.6136 1.698-0.3002 3.319 0.8339 3.615 2.5314z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m77.574 252.86c0.3003 1.698-0.8343 3.317-2.5326 3.614-1.6982 0.296-3.3186-0.834-3.6153-2.532-0.3003-1.697 0.8343-3.317 2.5326-3.613 1.6983-0.3 3.3187 0.834 3.6153 2.531z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m125.4 298.48c-1.673-0.422-2.685-2.12-2.262-3.791 0.422-1.672 2.121-2.683 3.793-2.261 1.672 0.423 2.685 2.12 2.262 3.792-0.423 1.671-2.121 2.683-3.793 2.26z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m140.37 183.78c-1.672-0.422-2.685-2.12-2.262-3.791 0.423-1.672 2.121-2.684 3.793-2.261 1.673 0.422 2.685 2.12 2.262 3.791-0.423 1.672-2.121 2.684-3.793 2.261z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.4"
        />
        <path
          d="m900.88 308.8c-1.672-0.422-2.685-2.12-2.262-3.791 0.423-1.672 2.121-2.683 3.793-2.261 1.673 0.423 2.685 2.12 2.262 3.792-0.422 1.671-2.121 2.683-3.793 2.26z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m918.61 269.35c-1.672-0.423-2.684-2.12-2.261-3.792 0.422-1.671 2.121-2.683 3.793-2.261 1.672 0.423 2.684 2.12 2.262 3.792-0.423 1.671-2.121 2.683-3.794 2.261z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m501.16 153.4c-1.672-0.422-2.684-2.12-2.261-3.791 0.422-1.672 2.121-2.683 3.793-2.261 1.672 0.423 2.684 2.12 2.262 3.792-0.423 1.671-2.121 2.683-3.794 2.26z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m623.82 243.52c0.301 1.697-0.834 3.317-2.532 3.614-1.699 0.3-3.319-0.834-3.616-2.532-0.3-1.697 0.835-3.317 2.533-3.613 1.698-0.301 3.319 0.833 3.615 2.531z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m83.169 392.7c0.3004 1.698-0.8343 3.318-2.5325 3.614-1.6983 0.297-3.3187-0.834-3.6153-2.531-0.3004-1.698 0.8343-3.317 2.5326-3.614 1.6982-0.3 3.3186 0.834 3.6152 2.531z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m74.689 377.78c0.3004 1.697-0.8343 3.317-2.5325 3.613-1.6983 0.301-3.3187-0.834-3.6153-2.531-0.3004-1.697 0.8343-3.317 2.5325-3.614 1.6983-0.3 3.3187 0.834 3.6153 2.532z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m95.091 374.8c0.3003 1.698-0.8343 3.317-2.5326 3.614-1.6982 0.3-3.3186-0.834-3.6153-2.532-0.3003-1.697 0.8343-3.317 2.5326-3.613 1.6983-0.3 3.3187 0.834 3.6153 2.531z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m710.08 332.45c0.3 1.698-0.834 3.317-2.533 3.614-1.698 0.3-3.318-0.834-3.615-2.531-0.3-1.698 0.834-3.318 2.533-3.614 1.698-0.297 3.318 0.834 3.615 2.531z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m476.66 187.54c0.3 1.697-0.835 3.317-2.533 3.613-1.698 0.3-3.319-0.834-3.615-2.531-0.301-1.698 0.834-3.317 2.532-3.614 1.699-0.3 3.319 0.834 3.616 2.532z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m541.71 133.14c0.163 0.919-0.453 1.797-1.372 1.961-0.92 0.163-1.799-0.453-1.962-1.372s0.453-1.797 1.372-1.96c0.92-0.163 1.799 0.452 1.962 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m700.78 292.57c0.163 0.919-0.452 1.798-1.372 1.961-0.919 0.163-1.798-0.452-1.961-1.371-0.163-0.92 0.452-1.798 1.372-1.961 0.919-0.163 1.798 0.452 1.961 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m409.42 289.26c0.163 0.919-0.453 1.798-1.372 1.961-0.92 0.163-1.799-0.453-1.962-1.372s0.453-1.797 1.372-1.96c0.92-0.163 1.799 0.452 1.962 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m13.819 307.02c0.3004 1.698-0.8343 3.317-2.5325 3.614-1.6983 0.3-3.3187-0.834-3.6153-2.532-0.29664-1.697 0.8343-3.317 2.5325-3.613 1.6983-0.301 3.3187 0.834 3.6153 2.531z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m171.42 69.959c0.3 1.6974-0.835 3.3171-2.533 3.6136-1.698 0.3002-3.319-0.8339-3.615-2.5314-0.301-1.6975 0.834-3.3171 2.532-3.6136 1.699-0.3002 3.319 0.8339 3.616 2.5314z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m155.11 89.41c0.301 1.6975-0.834 3.3171-2.532 3.6136-1.699 0.3002-3.319-0.8339-3.616-2.5314-0.3-1.6974 0.835-3.317 2.533-3.6135 1.698-0.3003 3.319 0.8339 3.615 2.5313z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m182.24 99.228c0.301 1.6975-0.834 3.3175-2.532 3.6135-1.698 0.297-3.319-0.834-3.615-2.531-0.301-1.6977 0.834-3.3174 2.532-3.6139 1.698-0.3002 3.319 0.8339 3.615 2.5314z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m891.96 236.49c0.163 0.919-0.452 1.798-1.372 1.961s-1.798-0.452-1.961-1.372c-0.164-0.919 0.452-1.797 1.371-1.96 0.92-0.163 1.799 0.452 1.962 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m571.82 211.9c0.163 0.919-0.453 1.798-1.372 1.961-0.92 0.163-1.799-0.452-1.962-1.372-0.163-0.919 0.452-1.797 1.372-1.96s1.798 0.452 1.962 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m192.95 463.01c0.163 0.919-0.452 1.797-1.372 1.96-0.919 0.163-1.798-0.452-1.961-1.371s0.452-1.798 1.372-1.961c0.919-0.163 1.798 0.453 1.961 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m832.1 160.43c0.163 0.92-0.453 1.798-1.372 1.961-0.92 0.163-1.799-0.452-1.962-1.371s0.453-1.798 1.372-1.961c0.92-0.163 1.799 0.452 1.962 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m41.651 185.11c0.7824 0.507 1.0086 1.556 0.5006 2.338s-1.5574 1.008-2.3398 0.501c-0.7824-0.508-1.0085-1.557-0.5006-2.339 0.508-0.782 1.5574-1.008 2.3398-0.5z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m232.96 221.67c0.782 0.508 1.008 1.557 0.5 2.339s-1.557 1.008-2.339 0.5c-0.783-0.508-1.009-1.557-0.501-2.339s1.557-1.008 2.34-0.5z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m44.914 138.92c0.1632 0.92-0.4524 1.798-1.372 1.961-0.9195 0.163-1.7983-0.452-1.9615-1.371-0.1631-0.919 0.4524-1.798 1.372-1.961s1.7984 0.452 1.9615 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m49.805 152.69c0.1631 0.919-0.4524 1.797-1.372 1.96s-1.7984-0.452-1.9615-1.371c-0.1632-0.919 0.4524-1.797 1.3719-1.961 0.9196-0.163 1.7984 0.453 1.9616 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m777.96 185.94c0.163 0.919-0.453 1.797-1.372 1.96-0.92 0.163-1.799-0.452-1.962-1.371s0.452-1.798 1.372-1.961 1.798 0.452 1.962 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m768.3 137.76c0.164 0.919-0.452 1.797-1.371 1.96-0.92 0.163-1.799-0.452-1.962-1.371s0.452-1.798 1.372-1.961 1.798 0.452 1.961 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m523.49 176.98c0.164 0.919-0.452 1.797-1.371 1.96-0.92 0.163-1.799-0.452-1.962-1.371s0.452-1.798 1.372-1.961 1.798 0.452 1.961 1.372z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m369.56 221.66c0.163 0.919-0.452 1.797-1.372 1.961-0.919 0.163-1.798-0.453-1.961-1.372-0.164-0.919 0.452-1.797 1.372-1.96 0.919-0.163 1.798 0.452 1.961 1.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m535.51 299.56c0 1.049-0.849 1.902-1.902 1.902s-1.902-0.849-1.902-1.902c0-1.052 0.852-1.901 1.902-1.901 1.049 0 1.902 0.852 1.902 1.901z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m566.67 242.45c0.498 0 0.901-0.403 0.901-0.901 0-0.497-0.403-0.9-0.901-0.9s-0.901 0.403-0.901 0.9c0 0.498 0.403 0.901 0.901 0.901z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m686.28 225.64c0 0.581-0.471 1.052-1.054 1.052-0.582 0-1.053-0.471-1.053-1.052 0-0.582 0.471-1.053 1.053-1.053 0.583 0 1.054 0.471 1.054 1.053z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m590.26 214.53c0 0.997-0.808 1.809-1.809 1.809s-1.81-0.808-1.81-1.809 0.809-1.809 1.81-1.809 1.809 0.808 1.809 1.809z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m587.75 179.21c0 1.197-0.968 2.165-2.165 2.165-1.198 0-2.166-0.968-2.166-2.165s0.968-2.164 2.166-2.164c1.197 0 2.165 0.967 2.165 2.164z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m856.3 134.08c0 1.097-0.89 1.99-1.992 1.99-1.101 0-1.991-0.889-1.991-1.99s0.89-1.99 1.991-1.99c1.102 0 1.992 0.889 1.992 1.99z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m695.95 254.14c0 0.656-0.534 1.19-1.191 1.19-0.656 0-1.19-0.534-1.19-1.19s0.534-1.19 1.19-1.19c0.657 0 1.191 0.534 1.191 1.19z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m821.23 128.16c0 0.845-0.686 1.531-1.531 1.531-0.846 0-1.532-0.686-1.532-1.531s0.686-1.53 1.532-1.53c0.845 0 1.531 0.685 1.531 1.53z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m765.81 255.74c0 1.053-0.853 1.905-1.906 1.905s-1.906-0.852-1.906-1.905 0.853-1.905 1.906-1.905 1.906 0.852 1.906 1.905z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m814.95 260.76c0 0.537-0.434 0.971-0.972 0.971s-0.971-0.434-0.971-0.971 0.433-0.971 0.971-0.971 0.972 0.434 0.972 0.971z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m839.28 271.44c0 0.541-0.441 0.982-0.982 0.982-0.542 0-0.983-0.441-0.983-0.982s0.441-0.982 0.983-0.982c0.541 0 0.982 0.441 0.982 0.982z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m114.81 285.37c0 0.623-0.504 1.127-1.127 1.127s-1.127-0.504-1.127-1.127 0.504-1.127 1.127-1.127 1.127 0.504 1.127 1.127z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m20.137 282.11c0 0.823-0.6675 1.494-1.4943 1.494-0.8269 0-1.4944-0.667-1.4944-1.494 0-0.826 0.6675-1.493 1.4944-1.493 0.8268 0 1.4943 0.667 1.4943 1.493z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m137.5 271.45c0.696 0 1.261-0.564 1.261-1.26s-0.565-1.26-1.261-1.26-1.261 0.564-1.261 1.26 0.565 1.26 1.261 1.26z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m34.176 266.15c1.11 0 2.0097-0.899 2.0097-2.008 0-1.11-0.8997-2.009-2.0097-2.009-1.1099 0-2.0097 0.899-2.0097 2.009 0 1.109 0.8998 2.008 2.0097 2.008z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m237.14 206.75c0 1.109-0.897 2.009-2.009 2.009-1.113 0-2.01-0.897-2.01-2.009 0-1.111 0.897-2.008 2.01-2.008 1.112 0 2.009 0.897 2.009 2.008z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m258.18 188.62c1.11 0 2.01-0.899 2.01-2.009 0-1.109-0.9-2.008-2.01-2.008s-2.01 0.899-2.01 2.008c0 1.11 0.9 2.009 2.01 2.009z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m563.79 159.54c1.11 0 2.01-0.9 2.01-2.009 0-1.11-0.9-2.009-2.01-2.009s-2.01 0.899-2.01 2.009c0 1.109 0.9 2.009 2.01 2.009z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m906.56 203.88c0 1.108-0.897 2.009-2.01 2.009-1.112 0-2.009-0.897-2.009-2.009s0.897-2.009 2.009-2.009c1.113 0 2.01 0.897 2.01 2.009z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m119.42 243.62c0 1.078-0.875 1.953-1.954 1.953s-1.955-0.875-1.955-1.953c0-1.079 0.876-1.954 1.955-1.954s1.954 0.875 1.954 1.954z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m817.4 238.88c1.026 0 1.858-0.831 1.858-1.857 0-1.025-0.832-1.856-1.858-1.856s-1.858 0.831-1.858 1.856c0 1.026 0.832 1.857 1.858 1.857z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m798.94 241.63c0.678 0 1.228-0.549 1.228-1.227 0-0.677-0.55-1.227-1.228-1.227s-1.227 0.55-1.227 1.227c0 0.678 0.549 1.227 1.227 1.227z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m783.76 260.55c0 0.827-0.671 1.497-1.498 1.497-0.826 0-1.498-0.67-1.498-1.497 0-0.826 0.672-1.497 1.498-1.497 0.827 0 1.498 0.671 1.498 1.497z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m637.24 380.98c0 1.219-0.986 2.205-2.206 2.205s-2.207-0.986-2.207-2.205c0-1.22 0.987-2.206 2.207-2.206s2.206 0.986 2.206 2.206z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m611.44 133.43c0 0.715-0.579 1.293-1.294 1.293-0.716 0-1.294-0.578-1.294-1.293 0-0.716 0.578-1.294 1.294-1.294 0.715 0 1.294 0.578 1.294 1.294z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m663.78 317.56c0 0.511-0.416 0.926-0.927 0.926-0.512 0-0.927-0.415-0.927-0.926 0-0.512 0.415-0.927 0.927-0.927 0.511 0 0.927 0.415 0.927 0.927z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m636.86 315.09c0 0.649-0.527 1.179-1.179 1.179-0.653 0-1.18-0.526-1.18-1.179 0-0.652 0.527-1.178 1.18-1.178 0.652 0 1.179 0.526 1.179 1.178z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m612.95 158.7c0 0.649-0.526 1.179-1.179 1.179-0.652 0-1.179-0.526-1.179-1.179 0-0.652 0.527-1.178 1.179-1.178 0.653 0 1.179 0.526 1.179 1.178z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m600.94 264.58c0 0.841-0.682 1.523-1.524 1.523s-1.524-0.682-1.524-1.523 0.682-1.523 1.524-1.523 1.524 0.682 1.524 1.523z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m557.8 366.97c0 1.071-0.868 1.938-1.94 1.938-1.071 0-1.939-0.867-1.939-1.938s0.868-1.939 1.939-1.939c1.072 0 1.94 0.868 1.94 1.939z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m644.05 182.27c0 0.9-0.731 1.634-1.635 1.634-0.905 0-1.636-0.73-1.636-1.634 0-0.905 0.731-1.635 1.636-1.635 0.904 0 1.635 0.73 1.635 1.635z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m652.65 252.1c0 0.894-0.726 1.62-1.62 1.62s-1.62-0.726-1.62-1.62c0-0.893 0.726-1.619 1.62-1.619s1.62 0.726 1.62 1.619z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m629.89 142.16c0 1.219-0.987 2.205-2.207 2.205s-2.206-0.986-2.206-2.205 0.986-2.205 2.206-2.205 2.207 0.986 2.207 2.205z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m627.5 124.7c0 1.22-0.986 2.206-2.206 2.206s-2.206-0.986-2.206-2.206c0-1.219 0.986-2.205 2.206-2.205s2.206 0.986 2.206 2.205z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m855.93 213.91c1.114 0 2.017-0.903 2.017-2.017 0-1.113-0.903-2.016-2.017-2.016s-2.017 0.903-2.017 2.016c0 1.114 0.903 2.017 2.017 2.017z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m758.16 277.32c0 0.719-0.582 1.305-1.305 1.305s-1.305-0.582-1.305-1.305c0-0.722 0.582-1.304 1.305-1.304s1.305 0.582 1.305 1.304z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m642.41 242.9c0 0.504-0.408 0.916-0.916 0.916s-0.916-0.408-0.916-0.916 0.408-0.915 0.916-0.915 0.916 0.407 0.916 0.915z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m813.42 321.8c0 0.771-0.623 1.393-1.395 1.393-0.771 0-1.394-0.622-1.394-1.393s0.623-1.394 1.394-1.394c0.772 0 1.395 0.623 1.395 1.394z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m756.72 339.62c0 0.77-0.623 1.393-1.394 1.393s-1.394-0.623-1.394-1.393c0-0.771 0.623-1.394 1.394-1.394s1.394 0.623 1.394 1.394z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m820.38 324.27c0 1.053-0.852 1.909-1.909 1.909s-1.91-0.853-1.91-1.909 0.853-1.909 1.91-1.909 1.909 0.853 1.909 1.909z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m868.89 290.37c0 1.053-0.853 1.909-1.91 1.909-1.056 0-1.909-0.853-1.909-1.909s0.853-1.909 1.909-1.909c1.057 0 1.91 0.853 1.91 1.909z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m829.13 347.77c0 0.537-0.438 0.974-0.976 0.974-0.537 0-0.975-0.437-0.975-0.974 0-0.538 0.438-0.975 0.975-0.975 0.538 0 0.976 0.437 0.976 0.975z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m746.5 295.92c0 0.663-0.538 1.201-1.202 1.201s-1.201-0.538-1.201-1.201c0-0.664 0.537-1.201 1.201-1.201s1.202 0.537 1.202 1.201z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m887.09 382.96c0 0.894-0.727 1.62-1.62 1.62-0.894 0-1.621-0.726-1.621-1.62 0-0.893 0.727-1.619 1.621-1.619 0.893 0 1.62 0.726 1.62 1.619z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m13.474 405.66c0 0.893-0.7268 1.62-1.6204 1.62s-1.6204-0.727-1.6204-1.62 0.7268-1.619 1.6204-1.619 1.6204 0.726 1.6204 1.619z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m911.38 388.99c1.198 0 2.169-0.971 2.169-2.168 0-1.198-0.971-2.169-2.169-2.169s-2.169 0.971-2.169 2.169c0 1.197 0.971 2.168 2.169 2.168z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m19.399 426.02c0 0.704-0.571 1.279-1.2793 1.279-0.7082 0-1.2792-0.571-1.2792-1.279s0.571-1.278 1.2792-1.278c0.7083 0 1.2793 0.57 1.2793 1.278z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m74.107 304.75c0 1.149-0.9307 2.08-2.0802 2.08s-2.0802-0.931-2.0802-2.08 0.9307-2.079 2.0802-2.079 2.0802 0.93 2.0802 2.079z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m67.47 277.82c0 0.945-0.7639 1.708-1.7094 1.708-0.9456 0-1.7094-0.763-1.7094-1.708 0-0.946 0.7638-1.709 1.7094-1.709 0.9455 0 1.7094 0.763 1.7094 1.709z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m129.97 208.27c0 1.067-0.868 1.935-1.936 1.935s-1.935-0.868-1.935-1.935 0.867-1.935 1.935-1.935 1.936 0.868 1.936 1.935z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m237.26 354.79c0 0.871-0.704 1.575-1.576 1.575-0.871 0-1.575-0.704-1.575-1.575s0.704-1.575 1.575-1.575c0.872 0 1.576 0.704 1.576 1.575z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m585.58 244.81c0 0.9-0.731 1.627-1.628 1.627s-1.628-0.731-1.628-1.627c0-0.897 0.731-1.627 1.628-1.627s1.628 0.73 1.628 1.627z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m263.89 312.03c0 0.819-0.663 1.483-1.483 1.483-0.819 0-1.483-0.664-1.483-1.483s0.664-1.482 1.483-1.482c0.82 0 1.483 0.663 1.483 1.482z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m388.09 238.64c0 1.089-0.882 1.975-1.976 1.975s-1.977-0.882-1.977-1.975c0-1.094 0.883-1.976 1.977-1.976s1.976 0.882 1.976 1.976z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m233.46 275.11c0 0.675-0.549 1.223-1.224 1.223s-1.224-0.548-1.224-1.223c0-0.674 0.549-1.223 1.224-1.223s1.224 0.549 1.224 1.223z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m46.757 199.54c1.0423 0 1.8873-0.844 1.8873-1.886s-0.845-1.887-1.8873-1.887c-1.0424 0-1.8874 0.845-1.8874 1.887s0.845 1.886 1.8874 1.886z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m53.42 170.94c0 0.868-0.7045 1.572-1.5722 1.572-0.8676 0-1.5722-0.704-1.5722-1.572 0-0.867 0.7046-1.571 1.5722-1.571 0.8677 0 1.5722 0.704 1.5722 1.571z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m63.958 147.89c0 0.741-0.6007 1.346-1.346 1.346s-1.346-0.601-1.346-1.346 0.6007-1.345 1.346-1.345 1.346 0.6 1.346 1.345z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m881.55 371.25c0.815 0 1.475-0.66 1.475-1.475 0-0.814-0.66-1.475-1.475-1.475s-1.476 0.661-1.476 1.475c0 0.815 0.661 1.475 1.476 1.475z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m62.304 298.59c0 1.104-0.8937 1.997-1.9987 1.997-1.1049 0-1.9986-0.893-1.9986-1.997 0-1.105 0.8937-1.998 1.9986-1.998 1.105 0 1.9987 0.893 1.9987 1.998z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m77.934 281.45c1.028 0 1.8614-0.833 1.8614-1.861 0-1.027-0.8334-1.86-1.8614-1.86-1.0281 0-1.8614 0.833-1.8614 1.86 0 1.028 0.8333 1.861 1.8614 1.861z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m13.262 361.59c0.7802 0 1.4127-0.632 1.4127-1.412s-0.6325-1.412-1.4127-1.412c-0.7803 0-1.4128 0.632-1.4128 1.412s0.6325 1.412 1.4128 1.412z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m48.266 312.35c0 0.834-0.6749 1.508-1.5092 1.508s-1.5091-0.674-1.5091-1.508 0.6748-1.509 1.5091-1.509 1.5092 0.675 1.5092 1.509z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m210.62 348.21c0 0.596-0.482 1.078-1.079 1.078s-1.079-0.482-1.079-1.078c0-0.597 0.482-1.079 1.079-1.079s1.079 0.482 1.079 1.079z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m195.01 328.41c0 0.649-0.527 1.171-1.172 1.171s-1.171-0.526-1.171-1.171 0.526-1.171 1.171-1.171 1.172 0.526 1.172 1.171z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m850.21 297.26c0.506 0 0.916-0.41 0.916-0.916s-0.41-0.915-0.916-0.915-0.916 0.409-0.916 0.915 0.41 0.916 0.916 0.916z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m27.531 249.27c0.7044 0 1.2755-0.571 1.2755-1.275 0-0.705-0.5711-1.275-1.2755-1.275-0.7045 0-1.2756 0.57-1.2756 1.275 0 0.704 0.5711 1.275 1.2756 1.275z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m182.1 59.73c0 0.9488-0.768 1.716-1.717 1.716s-1.717-0.7672-1.717-1.716 0.768-1.716 1.717-1.716 1.717 0.7672 1.717 1.716z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m790.88 145.38c0 1.064-0.864 1.928-1.928 1.928s-1.928-0.864-1.928-1.928c0-1.063 0.864-1.927 1.928-1.927s1.928 0.864 1.928 1.927z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m18.646 191.26c0 1.116-0.9047 2.024-2.0246 2.024-1.1198 0-2.0245-0.904-2.0245-2.024 0-1.119 0.9047-2.023 2.0245-2.023 1.1199 0 2.0246 0.904 2.0246 2.023z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m39.011 242.56c0 0.782-0.634 1.416-1.4164 1.416s-1.4165-0.634-1.4165-1.416 0.6341-1.416 1.4165-1.416 1.4164 0.634 1.4164 1.416z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m220.7 266.6c0 0.926-0.753 1.679-1.68 1.679s-1.68-0.753-1.68-1.679c0-0.927 0.753-1.679 1.68-1.679s1.68 0.752 1.68 1.679z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m209.7 296.12c0.549 0 0.994-0.444 0.994-0.993s-0.445-0.993-0.994-0.993c-0.548 0-0.993 0.444-0.993 0.993s0.445 0.993 0.993 0.993z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m217.37 320.03c0 1.03-0.838 1.868-1.869 1.868s-1.869-0.838-1.869-1.868 0.838-1.868 1.869-1.868 1.869 0.838 1.869 1.868z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m107.72 344.69c0 0.834-0.675 1.509-1.509 1.509s-1.509-0.675-1.509-1.509c0-0.833 0.675-1.508 1.509-1.508s1.509 0.675 1.509 1.508z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m97.89 365.06c0 0.782-0.634 1.415-1.4164 1.415s-1.4165-0.633-1.4165-1.415c0-0.783 0.6341-1.416 1.4165-1.416s1.4164 0.633 1.4164 1.416z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m855.21 310.44c0 0.782-0.634 1.416-1.417 1.416-0.782 0-1.416-0.634-1.416-1.416s0.634-1.416 1.416-1.416c0.783 0 1.417 0.634 1.417 1.416z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m188.4 365.53c0 0.66-0.534 1.193-1.194 1.193s-1.194-0.533-1.194-1.193 0.534-1.193 1.194-1.193 1.194 0.533 1.194 1.193z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m198.8 371.86c0 0.946-0.764 1.709-1.71 1.709-0.945 0-1.709-0.763-1.709-1.709 0-0.945 0.764-1.708 1.709-1.708 0.946 0 1.71 0.763 1.71 1.708z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m57.417 333.35c0 1.068-0.864 1.931-1.9319 1.931s-1.9318-0.863-1.9318-1.931c0-1.067 0.8639-1.931 1.9318-1.931s1.9319 0.864 1.9319 1.931z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m113.1 317.6c0.974 0 1.765-0.79 1.765-1.764 0-0.975-0.791-1.764-1.765-1.764-0.975 0-1.765 0.789-1.765 1.764 0 0.974 0.79 1.764 1.765 1.764z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m831.77 311.1c0.576 0 1.042-0.467 1.042-1.042s-0.466-1.041-1.042-1.041c-0.575 0-1.042 0.466-1.042 1.041s0.467 1.042 1.042 1.042z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m808.47 296.35c0.651 0 1.179-0.528 1.179-1.179 0-0.65-0.528-1.178-1.179-1.178-0.652 0-1.18 0.528-1.18 1.178 0 0.651 0.528 1.179 1.18 1.179z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m717.66 266.33c0 0.923-0.749 1.672-1.672 1.672-0.924 0-1.673-0.749-1.673-1.672 0-0.922 0.749-1.671 1.673-1.671 0.923 0 1.672 0.749 1.672 1.671z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m676.23 274.18c0 0.827-0.672 1.494-1.495 1.494s-1.494-0.671-1.494-1.494 0.671-1.494 1.494-1.494 1.495 0.671 1.495 1.494z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m662.62 251.08c0.84 0 1.52-0.68 1.52-1.519 0-0.84-0.68-1.52-1.52-1.52s-1.52 0.68-1.52 1.52c0 0.839 0.68 1.519 1.52 1.519z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m567.1 187.72c0 0.911-0.741 1.653-1.653 1.653s-1.654-0.742-1.654-1.653c0-0.912 0.742-1.653 1.654-1.653s1.653 0.741 1.653 1.653z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m611.77 178.26c0.914 0 1.654-0.74 1.654-1.653 0-0.912-0.74-1.653-1.654-1.653-0.913 0-1.653 0.741-1.653 1.653 0 0.913 0.74 1.653 1.653 1.653z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m545.86 365.32c1.073 0 1.943-0.869 1.943-1.942s-0.87-1.942-1.943-1.942-1.943 0.869-1.943 1.942 0.87 1.942 1.943 1.942z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m537.83 218.73c1.226 0 2.221-0.994 2.221-2.22s-0.995-2.22-2.221-2.22c-1.227 0-2.222 0.994-2.222 2.22s0.995 2.22 2.222 2.22z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m623.05 97.597c1.227 0 2.221-0.9939 2.221-2.22s-0.994-2.2201-2.221-2.2201-2.221 0.994-2.221 2.2201 0.994 2.22 2.221 2.22z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m517.58 229.12c0 1.023-0.827 1.85-1.85 1.85-1.024 0-1.851-0.827-1.851-1.85s0.827-1.849 1.851-1.849c1.023 0 1.85 0.826 1.85 1.849z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m489.89 229.44c0 0.69-0.556 1.246-1.245 1.246-0.69 0-1.246-0.556-1.246-1.246 0-0.689 0.556-1.245 1.246-1.245 0.689 0 1.245 0.556 1.245 1.245z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m473.91 238.07c0 0.649-0.526 1.179-1.179 1.179s-1.179-0.527-1.179-1.179 0.526-1.179 1.179-1.179 1.179 0.527 1.179 1.179z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m497.92 245.13c1.231 0 2.229-0.998 2.229-2.228s-0.998-2.227-2.229-2.227c-1.23 0-2.228 0.997-2.228 2.227s0.998 2.228 2.228 2.228z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m503.79 287.94c0 1.034-0.838 1.871-1.873 1.871-1.034 0-1.872-0.837-1.872-1.871s0.838-1.872 1.872-1.872c1.035 0 1.873 0.838 1.873 1.872z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m514.56 272.29c0.842 0 1.524-0.682 1.524-1.523s-0.682-1.523-1.524-1.523-1.524 0.682-1.524 1.523 0.682 1.523 1.524 1.523z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m571.69 266.33c0 0.627-0.508 1.131-1.131 1.131s-1.131-0.508-1.131-1.131c0-0.622 0.508-1.13 1.131-1.13s1.131 0.508 1.131 1.13z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m642.57 129.38c0 0.812-0.66 1.472-1.472 1.472s-1.472-0.66-1.472-1.472c0-0.811 0.66-1.471 1.472-1.471s1.472 0.66 1.472 1.471z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m525 91.478c0 1.2193-0.986 2.2052-2.206 2.2052s-2.206-0.9859-2.206-2.2052c0-1.2194 0.986-2.2052 2.206-2.2052s2.206 0.9858 2.206 2.2052z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m508.55 78.543c0 1.2193-0.986 2.2052-2.206 2.2052s-2.206-0.9859-2.206-2.2052c0-1.2194 0.986-2.2053 2.206-2.2053s2.206 0.9859 2.206 2.2053z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m521.83 73.176c0.813 0 1.473-0.6588 1.473-1.4714s-0.66-1.4714-1.473-1.4714-1.472 0.6588-1.472 1.4714 0.659 1.4714 1.472 1.4714z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m601.16 275.46c0.705 0 1.276-0.571 1.276-1.275s-0.571-1.275-1.276-1.275c-0.704 0-1.275 0.571-1.275 1.275s0.571 1.275 1.275 1.275z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m673.7 237.52c0.704 0 1.275-0.57 1.275-1.275 0-0.704-0.571-1.274-1.275-1.274-0.705 0-1.276 0.57-1.276 1.274 0 0.705 0.571 1.275 1.276 1.275z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m574.24 297.66c0 0.96-0.779 1.742-1.743 1.742s-1.743-0.778-1.743-1.742 0.779-1.742 1.743-1.742 1.743 0.778 1.743 1.742z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m533.89 257.21c0 1.205-0.976 2.18-2.181 2.18s-2.18-0.975-2.18-2.18c0-1.204 0.975-2.179 2.18-2.179s2.181 0.975 2.181 2.179z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m792.16 341.76c0 0.578-0.467 1.045-1.045 1.045-0.579 0-1.046-0.467-1.046-1.045s0.467-1.045 1.046-1.045c0.578 0 1.045 0.467 1.045 1.045z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m715.36 207.41c0 1.238-1.005 2.242-2.243 2.242-1.239 0-2.243-1.004-2.243-2.242s1.004-2.242 2.243-2.242c1.238 0 2.243 1.004 2.243 2.242z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m480.73 180.75c0.923 0 1.672-0.749 1.672-1.672s-0.749-1.671-1.672-1.671c-0.924 0-1.673 0.748-1.673 1.671s0.749 1.672 1.673 1.672z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m116.62 165.42c0 0.993-0.808 1.801-1.802 1.801-0.993 0-1.802-0.808-1.802-1.801 0-0.994 0.809-1.801 1.802-1.801 0.994 0 1.802 0.807 1.802 1.801z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m138.14 376.21c0 0.993-0.809 1.801-1.802 1.801-0.994 0-1.803-0.808-1.803-1.801 0-0.994 0.809-1.802 1.803-1.802 0.993 0 1.802 0.808 1.802 1.802z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m6.536 282.56c0 0.656-0.53395 1.189-1.1903 1.189-0.65632 0-1.1903-0.533-1.1903-1.189s0.53395-1.19 1.1903-1.19c0.65631 0 1.1903 0.534 1.1903 1.19z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m210.34 199.7c0 0.901-0.731 1.634-1.635 1.634-0.905 0-1.636-0.73-1.636-1.634s0.731-1.635 1.636-1.635c0.904 0 1.635 0.731 1.635 1.635z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m893.54 288.88c0 0.893-0.727 1.62-1.621 1.62-0.893 0-1.62-0.727-1.62-1.62s0.727-1.62 1.62-1.62c0.894 0 1.621 0.727 1.621 1.62z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m513.04 374.64c0 1.22-0.986 2.205-2.206 2.205s-2.206-0.985-2.206-2.205c0-1.219 0.986-2.205 2.206-2.205s2.206 0.986 2.206 2.205z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m901.64 251.45c0 0.826-0.671 1.493-1.495 1.493-0.823 0-1.494-0.67-1.494-1.493s0.671-1.494 1.494-1.494c0.824 0 1.495 0.671 1.495 1.494z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m919.38 181.52c0.84 0 1.521-0.68 1.521-1.52 0-0.839-0.681-1.519-1.521-1.519-0.839 0-1.52 0.68-1.52 1.519 0 0.84 0.681 1.52 1.52 1.52z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m173.65 85.596c0.682 0 1.235-0.5526 1.235-1.2342s-0.553-1.2342-1.235-1.2342-1.235 0.5526-1.235 1.2342 0.553 1.2342 1.235 1.2342z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m848.61 259.18c0.885 0 1.602-0.717 1.602-1.601s-0.717-1.601-1.602-1.601-1.602 0.717-1.602 1.601 0.717 1.601 1.602 1.601z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m509.12 398.08c0 0.811-0.656 1.467-1.468 1.467s-1.468-0.656-1.468-1.467c0-0.812 0.66-1.468 1.468-1.468s1.468 0.656 1.468 1.468z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m511.72 332.94c0 1.131-0.92 2.05-2.051 2.05s-2.05-0.919-2.05-2.05c0-1.13 0.919-2.049 2.05-2.049s2.051 0.919 2.051 2.049z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m650.41 208.97c0 0.548-0.445 0.996-0.997 0.996-0.553 0-0.998-0.444-0.998-0.996 0-0.553 0.445-0.997 0.998-0.997 0.552 0 0.997 0.444 0.997 0.997z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m744.06 273.4c1.172 0 2.121-0.949 2.121-2.12s-0.949-2.12-2.121-2.12c-1.171 0-2.121 0.949-2.121 2.12s0.95 2.12 2.121 2.12z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m684.32 136.59c0 0.812-0.66 1.472-1.472 1.472s-1.472-0.66-1.472-1.472 0.66-1.471 1.472-1.471 1.472 0.659 1.472 1.471z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m99.904 246.81c0 0.508-0.4116 0.916-0.9158 0.916-0.5043 0-0.9159-0.412-0.9159-0.916s0.4116-0.915 0.9159-0.915c0.5042 0 0.9158 0.411 0.9158 0.915z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m133.19 237.46c0 1.201-0.971 2.172-2.173 2.172-1.201 0-2.173-0.971-2.173-2.172s0.972-2.172 2.173-2.172c1.202 0 2.173 0.971 2.173 2.172z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m117.26 232.68c0 1.149-0.931 2.083-2.084 2.083-1.154 0-2.084-0.931-2.084-2.083 0-1.153 0.93-2.083 2.084-2.083 1.153 0 2.084 0.93 2.084 2.083z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m93.633 217.93c0 0.894-0.7231 1.616-1.6167 1.616s-1.6167-0.722-1.6167-1.616c0-0.893 0.7231-1.615 1.6167-1.615s1.6167 0.722 1.6167 1.615z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m152.29 59.267c0 0.9265-0.749 1.6752-1.676 1.6752s-1.676-0.7487-1.676-1.6752c0-0.9266 0.749-1.6753 1.676-1.6753s1.676 0.7487 1.676 1.6753z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m859.55 115.32c0 0.538-0.438 0.975-0.976 0.975-0.537 0-0.975-0.437-0.975-0.975 0-0.537 0.438-0.974 0.975-0.974 0.538 0 0.976 0.437 0.976 0.974z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m825.95 108.49c0.696 0 1.261-0.564 1.261-1.26s-0.565-1.26-1.261-1.26-1.261 0.564-1.261 1.26 0.565 1.26 1.261 1.26z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m794.39 120.59c0.761 0 1.379-0.618 1.379-1.379 0-0.762-0.618-1.379-1.379-1.379-0.762 0-1.38 0.617-1.38 1.379 0 0.761 0.618 1.379 1.38 1.379z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m777.26 134.72c0 0.534-0.434 0.968-0.968 0.968s-0.968-0.434-0.968-0.968c0-0.533 0.434-0.967 0.968-0.967s0.968 0.434 0.968 0.967z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m811.1 113.18c0 0.968-0.786 1.753-1.753 1.753-0.968 0-1.754-0.785-1.754-1.753 0-0.967 0.786-1.753 1.754-1.753 0.967 0 1.753 0.786 1.753 1.753z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m167.53 179.21c0 1.068-0.864 1.931-1.932 1.931s-1.932-0.863-1.932-1.931c0-1.067 0.864-1.931 1.932-1.931s1.932 0.864 1.932 1.931z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m398.27 317.84c1.041 0 1.884-0.843 1.884-1.883s-0.843-1.883-1.884-1.883c-1.04 0-1.883 0.843-1.883 1.883s0.843 1.883 1.883 1.883z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m370.15 423.29c0 1.23-0.997 2.224-2.225 2.224-1.227 0-2.225-0.997-2.225-2.224s0.998-2.224 2.225-2.224c1.228 0 2.225 0.997 2.225 2.224z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m261.19 440.66c0 0.804-0.653 1.456-1.457 1.456-0.805 0-1.457-0.652-1.457-1.456 0-0.805 0.652-1.457 1.457-1.457 0.804 0 1.457 0.652 1.457 1.457z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m376.64 296.57c0.85 0 1.539-0.689 1.539-1.538 0-0.85-0.689-1.539-1.539-1.539s-1.539 0.689-1.539 1.539c0 0.849 0.689 1.538 1.539 1.538z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m456.19 333.65c0 1.1-0.894 1.997-1.999 1.997s-1.998-0.893-1.998-1.997c0-1.105 0.893-1.998 1.998-1.998s1.999 0.893 1.999 1.998z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m459.52 284.43c0 0.827-0.671 1.501-1.502 1.501-0.83 0-1.501-0.67-1.501-1.501 0-0.83 0.671-1.501 1.501-1.501 0.831 0 1.502 0.671 1.502 1.501z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m493.37 467.56c0 0.826-0.671 1.501-1.502 1.501-0.83 0-1.501-0.671-1.501-1.501 0-0.831 0.671-1.501 1.501-1.501 0.831 0 1.502 0.67 1.502 1.501z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m440.18 419.55c0 0.827-0.671 1.502-1.502 1.502-0.83 0-1.501-0.671-1.501-1.502 0-0.83 0.671-1.501 1.501-1.501 0.831 0 1.502 0.671 1.502 1.501z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m374.67 139.53c0 1.156-0.938 2.098-2.099 2.098s-2.099-0.938-2.099-2.098 0.938-2.098 2.099-2.098 2.099 0.938 2.099 2.098z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m157.68 199.04c0 1.157-0.938 2.098-2.098 2.098-1.161 0-2.099-0.937-2.099-2.098 0-1.16 0.938-2.097 2.099-2.097 1.16 0 2.098 0.937 2.098 2.097z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m470.82 281.16c0.901 0 1.632-0.73 1.632-1.631 0-0.9-0.731-1.63-1.632-1.63s-1.631 0.73-1.631 1.63c0 0.901 0.73 1.631 1.631 1.631z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m455.39 254.86c0.497 0 0.901-0.403 0.901-0.901 0-0.497-0.404-0.9-0.901-0.9-0.498 0-0.901 0.403-0.901 0.9 0 0.498 0.403 0.901 0.901 0.901z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m456.29 300.82c0.524 0 0.949-0.424 0.949-0.948s-0.425-0.949-0.949-0.949-0.949 0.425-0.949 0.949 0.425 0.948 0.949 0.948z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m394.08 257.21c0 1.205-0.975 2.18-2.18 2.18s-2.18-0.975-2.18-2.18c0-1.204 0.975-2.179 2.18-2.179s2.18 0.975 2.18 2.179z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m479.48 374.64c0 0.608-0.493 1.101-1.101 1.101s-1.102-0.493-1.102-1.101 0.494-1.101 1.102-1.101 1.101 0.493 1.101 1.101z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m363.47 445.1c0 0.927-0.753 1.679-1.68 1.679s-1.68-0.752-1.68-1.679c0-0.926 0.753-1.679 1.68-1.679s1.68 0.753 1.68 1.679z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m384.09 364.99c0.889 0 1.609-0.72 1.609-1.608s-0.72-1.609-1.609-1.609-1.609 0.721-1.609 1.609 0.72 1.608 1.609 1.608z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m419.66 375.72c1.21 0 2.191-0.981 2.191-2.191 0-1.209-0.981-2.19-2.191-2.19s-2.192 0.981-2.192 2.19c0 1.21 0.982 2.191 2.192 2.191z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m243.59 38.471c1.211 0 2.192-0.9807 2.192-2.1904s-0.981-2.1904-2.192-2.1904c-1.21 0-2.191 0.9807-2.191 2.1904s0.981 2.1904 2.191 2.1904z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m354.59 388.36c0.976 0 1.768-0.791 1.768-1.768 0-0.976-0.792-1.768-1.768-1.768-0.977 0-1.769 0.792-1.769 1.768 0 0.977 0.792 1.768 1.769 1.768z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m409.55 251.34c0 1.134-0.92 2.057-2.058 2.057-1.139 0-2.058-0.919-2.058-2.057 0-1.137 0.919-2.057 2.058-2.057 1.138 0 2.058 0.92 2.058 2.057z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m290.66 418.01c1.161 0 2.102-0.941 2.102-2.101 0-1.161-0.941-2.102-2.102-2.102-1.162 0-2.103 0.941-2.103 2.102 0 1.16 0.941 2.101 2.103 2.101z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m288.07 51.046c0 1.1601-0.942 2.1015-2.102 2.1015-1.161 0-2.103-0.9414-2.103-2.1015 0-1.16 0.942-2.1014 2.103-2.1014 1.16 0 2.102 0.9414 2.102 2.1014z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m324.26 389.4c0 0.507-0.412 0.922-0.924 0.922-0.511 0-0.923-0.411-0.923-0.922 0-0.512 0.412-0.923 0.923-0.923 0.512 0 0.924 0.411 0.924 0.923z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m412.83 489.88c0 0.596-0.486 1.082-1.083 1.082s-1.083-0.486-1.083-1.082c0-0.597 0.486-1.083 1.083-1.083s1.083 0.486 1.083 1.083z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m366.29 539.23c0 1.079-0.875 1.953-1.954 1.953s-1.955-0.874-1.955-1.953c0-1.078 0.876-1.953 1.955-1.953s1.954 0.875 1.954 1.953z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m332.29 423.29c0.661 0 1.197-0.536 1.197-1.197s-0.536-1.197-1.197-1.197c-0.662 0-1.198 0.536-1.198 1.197s0.536 1.197 1.198 1.197z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m328.75 405.03c0 0.589-0.479 1.064-1.065 1.064s-1.064-0.478-1.064-1.064c0-0.585 0.478-1.064 1.064-1.064s1.065 0.479 1.065 1.064z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m308.95 388.36c0.809 0 1.465-0.656 1.465-1.464 0-0.809-0.656-1.464-1.465-1.464s-1.464 0.655-1.464 1.464c0 0.808 0.655 1.464 1.464 1.464z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m525.73 161.37c0.662 0 1.198-0.536 1.198-1.197s-0.536-1.197-1.198-1.197c-0.661 0-1.198 0.536-1.198 1.197s0.537 1.197 1.198 1.197z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m440.68 259.99c1.106 0 2.003-0.896 2.003-2.001s-0.897-2.001-2.003-2.001c-1.105 0-2.002 0.896-2.002 2.001s0.897 2.001 2.002 2.001z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m430.17 266.35c0 0.841-0.683 1.523-1.524 1.523-0.842 0-1.524-0.682-1.524-1.523 0-0.842 0.682-1.524 1.524-1.524 0.841 0 1.524 0.682 1.524 1.524z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m466.11 237.83c0 0.827-0.671 1.498-1.498 1.498s-1.498-0.671-1.498-1.498c0-0.826 0.671-1.497 1.498-1.497s1.498 0.671 1.498 1.497z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m300.06 112.31c0 0.915-0.741 1.656-1.657 1.656s-1.658-0.741-1.658-1.656c0-0.916 0.742-1.657 1.658-1.657s1.657 0.741 1.657 1.657z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity=".12"
        />
        <path
          d="m169.38 135.08 16.838-1.208 0.234 18.383-17.072-17.175zl-2.429 26.444 19.501-9.269 0.382 30.05-9.178-8.777 8.796-21.273-4.079 44.349 4.461-14.299 3.459 34.553-7.92-20.254-4.717-23.076-10.705-12.004 1.313 31.751 9.392-19.747-5.58 47.314-3.812-27.567 14.109 3.329-10.297 24.238 18.217-3.984 1.769 18.431-19.986-14.447 2.714 25.874 17.272-11.427 4.023 18.858-21.295-7.431-12.155 11.274-11.91-14.013 24.065 2.739 16.323 25.836 4.972-18.405 9.578 32.774-14.55-14.369-12.129-6.404 16.37 44.06-2.158-19.955-14.212-24.105 17.101-12.001-2.889 36.106-2.083-17.701"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m205.67 286.92-12.467 3.332 13.36 21.774-11.202-1.82 10.309-23.286z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m206.56 312.03 4.127 28.16-9.8-16.185 19.352-3.391-0.411 12.657-9.141 6.919 11.425 18.954-2.284-25.873 16.982 13.609-16.571-26.266-9.552 19.576 26.123 6.69 10.405 14.71-25.103-2.446 14.698-12.264v28.827l-9.856 15.67-21.762-3.869 31.618-11.801 27.313 3.944-16.908-18.061-10.405 14.117 18.507 19.569 8.806-15.625 20.135 14.476-28.941 1.149 13.953 12.461 14.988-13.61 19.623 13.61-20.031 9.929 0.408-23.539"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m269.27 407.74 14.58 9.929 20.216 11.2-0.185-21.129 21.05-12.531 1.798 20.785-22.848-8.254"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m304.07 428.86 22.663-12.875 18.373-12.694-20.171-8.766 19.037-15.421 1.134 24.187 11.102-10.055 6.259 9.187 20.672-0.011-26.931-9.176-12.236-14.132 14.324-0.719-2.088 14.851"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m343.97 379.11 19.17-22.016-4.846 21.297 16.905-19.247 2.703 12.712-19.608 6.535 19.608-41.066-14.762 19.769 12.059 2.05 16.711-9.436-14.008 22.148 12.844-45.472-12.844 10.941 14.008 12.383-1.164-23.324-1.591-10.429-11.253 21.37 29.59-16.633-15.582 29.016"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m390.74 326.38 16.745-5.693-18.336-4.737 10.082-19.591 8.254 24.328 12.174-26.559-20.428 2.231 7.602-24.917 12.826 22.686 4.512-16.311-17.338-6.375 4.824-22.178 18.158 12.39-5.644 16.163 1.903-29.828-19.241 23.453"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m442.04 169.37-20.538-17.127v43.282l17.535-43.27-17.535-0.012 11.509-8.872 6.026 8.884-0.204-17.175-5.822 8.291"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m429.82 261.66 5.154-26.037-8.895 12.372-7.865-23.353-6.552 24.628 14.417-1.275 12.599-39.672-3.704 27.3-6.986-23.427-9.774 12.446 3.293-29.113 6.481 16.667 10.69-3.873 1.94-23.713-19.111 10.919 20.538-26.155-14.057 42.822 11.054-59.938"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m442.04 169.37 10.49-10.685 13.62 10.685h-24.11z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m438.84 135.08-20.624-2.513 14.802 10.804-27.991-5.942 13.189-4.862 3.293 19.676-34.099-9.929 17.617-4.885 16.482 14.814"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m418.21 132.57-25.752-7.361 12.563 12.223-25.6-5.722 13.037-6.501-5.054 17.108-27.603-11.552 19.62 0.945-9.319-15.511 22.356 9.01-32.657 5.556 10.301-14.566h-19.033l8.732 14.566-29.493-12.342 20.761-2.224-9.151-12.063 28.184 12.063"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m341.92 104.14-10.979 14.287-0.334-20.203 11.313 5.9156z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m330.94 118.42-27.061-12.835 26.728-7.3676-26.728-12.864v20.232l-17.238 8.38 17.238-28.612-26.957 12.864 9.719 15.748-18.97 8.651 9.251-24.399-13.645 18.873-5.251-9.555 6.096-14.658-18.914-5.7373 12.818 20.396-13.033 25.984 22.678-10.903-4.394-5.526-18.284 16.429-8.273-16.429 21.306-9.555-28.907 31.677 15.874-5.693-35.449-6.067 27.176-10.362-19.348 16.781 11.747 5.341-21.403 7.802 9.656-13.143-7.828-6.419-1.828 19.562-21.495-13.143 23.323-6.419"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m186.46 152.26 21.261-5.241"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m303.88 105.59 0.107 31.522-17.346-23.142-13.549 26.819 30.895-3.677 0.041 25.581-15.811-9.703 15.77-15.878-36.316-13.576 5.421 17.253-28.099-7.265-1.383 18.724 29.482-11.459 15.125 12.201 2.64 27.456 13.171-17.753-0.041 28.567-13.13-10.814-24.328 0.311 21.688-27.767-44.607-0.742-14.491-13.031-4.457 32.704 18.948-19.673-35.894-5.229-5.48 19.417-15.781-14.177 38.207 19.662 28.8-3.48-9.852-16.193-21.425 44.698 2.477-25.025-22.426-5.485-15.4 15.874 11.202 14.298 4.198-30.172 20.561 30.51 30.665-28.505 34.755-15.451-23.568 52.576 26.208-25.12 0.782 29.134 12.348-18.32v29.943l-12.348-11.623-26.99-4.014 1.88-24.809-13.067-12.316-11.417 42.21 22.604-5.085-11.187-37.125-55.424 28.167-7.742 20.255 31.889-19.917-24.147-0.338 23.153 28.724 20.854-14.681-19.86-13.705-0.994 28.386-29.126 9.962 16.638 13.917 12.488-23.879 29.979 4.659-9.125-19.34-11.962 42.044-21.38-3.484-12.615 4.941 23.739 30.283-11.124-35.224-3.037 37.715 14.572 33.69-13.679-8.584-5.673 11.975-5.529-13.795"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m205.67 286.92 14.161-2.491 10.256-31.74 21.087-22.704 13.479-24.425 15.332 25.411 11.658-21.397-40.469 20.411 10.338 23.379 18.473-22.393-28.811-0.986-5.962 52.128-15.125-29.424 31.425 0.675 21.529 1.619-3.056-24.012 24.006-9.774v22.834l-20.95 10.952-22.589 15.207 1.06-16.826 12.459 26.351 9.07-24.732 20.95 10.552v-21.504l-24.006-13.06-49.898 21.718-0.134 50.598-10.122-18.858 25.381-2.316 3.726 28.427-18.985-7.253-24.283-16.367z"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m220.24 320.61 9.712-17.323 36.501-6.052-6.003-27.045-15.24 11.923 21.243 15.122 7.516-17.52 18.881-8.717-9.811-16.015 2.926 47.299 6.885-31.284 11.139-5.463v42.262l-11.139-36.799-26.397 26.237 19.512 5.047 18.024 5.515-0.107 21.226-14.996-3.076 15.103-18.15-43.35 24.658 25.326-30.173-37.029 8.258 11.703 21.915-40.399-11.845zl28.696-10.07 17.517-13.305-5.814 36.032-23.828 13.609 19.045 2.828 4.783-16.437 16.285 14.94 11.962-22.26-28.247 7.32 14.68 39.679-19.463-23.242-8.64 11.882 28.103 11.36-11.195 6.701 25.504-3.443-5.369 17.919-8.94-21.177 14.309 3.258 1.231-19.284-15.54 16.026 1.605-24.739 13.935 8.713 13.023-27.897 0.37 38.404-13.393-10.507 13.13 30.706 0.263-20.199-14.624 8.777 14.624 31.529"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m303.88 105.59 11.761 19.065 15.3-6.23-2.196 36.496-11.353-12.602 13.549-23.894 21.024 27.649 7.839-15.307-31.059 24.154-24.717 7.772 13.364-20.374-13.405-5.207 11.654-12.457 36.324 21.419 15.933-4.07-8.094-11.237 3.333 33.786 24.269-22.234-19.508-0.315 17.035 19.751 2.473-19.436 17.617 14.555 16.482-4.626-17.958 28.509 1.476-23.883-20.09 4.881 18.614 19.002 17.958 14.773-11.68 17.534-6.278-32.307-21.065 15.851-1.984-19.328 23.049 3.477-23.049 41.94 1.984-26.089-16.104-9.484 14.12-9.844 4.435-15.525-21.796 2.798 17.361 12.727-42.694 7.235 25.333-19.962-11.172-18.479-14.161 38.441-9.059-29.594-10.456 26.181-14.261-18.409-0.041 28.567 14.302-10.158 19.515 3.413-15.288 21.837-4.227-25.25 24.25 40.85 11.087-20.34-31.11 4.74-3.107 15.6-15.422-30.692 18.529 15.092 20.023 15.6 37.959 0.745-26.872-21.085-15.822-17.097 28.574 2.609-12.752 14.488 28.856-5.004 27.343 16.456 8.387 11.579-12.648 5.496 4.261-17.075-29.327 9.633-12.6 33.953 37.666-26.511 6.096 19.132-31.162-26.574 25.066 7.442-17.476 45.331 23.572-26.199-43.762 7.379-25.359-34.698h-23.13l-15.422-0.749 16.983 30.139-1.561-29.39 24.558 35.687-1.428-35.687-21.569 29.39-16.983-7.305 23.691 29.543-6.708-22.238 22.997 6.297 23.931-0.989-9.607 28.723 29.797-9.903-20.19-18.82-17.728 13.198 8.121 15.525 40.944 10.993-11.147-20.896 18.748-4.021-23.976 31.836 5.228-27.815-27.98 29.279-1.817-19.376-30.613-11.793 22.492-3.732-6.203-12.209-10.245 56.813 26.386-9.703 22.752-1.464 6.293 12.672-29.594 11.111 23.301-23.783-4.961 34.042-25.76 8.999 7.42-19.258 3.578 30.029-36.409 7.894 25.411-18.665-25.411-16.359 32.831-2.899 0.549-22.319-32.43-31.169-23.691-8.039 16.983 34.505 6.708-26.466-23.691 34.223 16.983-7.757 12.752 14.406-6.994 15.515-22.741-22.164 29.735 6.649-29.842 14.577 22.848 0.938v35.024l-22.848-35.962 48.259 17.297-8.172 32.786-17.239-14.121-1.798 30.217-20.68-27.775 22.478-2.442-22.478 42.748-0.263-20.107"
          stroke="var(--chart-302-icon-buttons-titles)"
          stroke-linejoin="round"
          stroke-opacity="0.8"
        />
        <path
          d="m364.3 400.17c1.246 1.012 1.439 2.843 0.426 4.088-1.012 1.246-2.844 1.438-4.089 0.426-1.246-1.011-1.439-2.842-0.427-4.088 1.012-1.245 2.844-1.438 4.09-0.426z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m351.01 268.81c0.571 0.463 0.657 1.301 0.193 1.871-0.463 0.571-1.301 0.656-1.873 0.193-0.571-0.463-0.656-1.301-0.192-1.872 0.463-0.57 1.301-0.656 1.872-0.192z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m384.27 301.55c0.957 0.774 1.102 2.179 0.327 3.135s-2.181 1.101-3.137 0.326c-0.957-0.774-1.102-2.179-0.327-3.135s2.181-1.101 3.137-0.326z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m440.08 287.47c0.957 0.774 1.101 2.179 0.326 3.135s-2.18 1.101-3.137 0.326c-0.956-0.774-1.101-2.179-0.326-3.135s2.18-1.101 3.137-0.326z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m400.64 294.63c0.956 0.775 1.101 2.179 0.326 3.135-0.775 0.957-2.18 1.101-3.137 0.327-0.957-0.775-1.101-2.18-0.326-3.136s2.18-1.101 3.137-0.326z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m361.41 303.14c0.883 0.716 1.02 2.017 0.301 2.899-0.716 0.882-2.018 1.019-2.9 0.3-0.883-0.715-1.02-2.016-0.3-2.898 0.715-0.883 2.017-1.02 2.899-0.301z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m365.03 354.76c1.29 1.045 1.487 2.939 0.441 4.229s-2.94 1.486-4.231 0.441c-1.29-1.045-1.487-2.939-0.441-4.229s2.94-1.486 4.231-0.441z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m335.65 312.07c1.317 1.067 1.517 2.995 0.449 4.31-1.068 1.316-2.996 1.516-4.312 0.449-1.317-1.068-1.517-2.995-0.449-4.311 1.068-1.315 2.996-1.515 4.312-0.448z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m358.51 390.4c1.568 1.271 1.806 3.573 0.534 5.137-1.272 1.568-3.575 1.805-5.139 0.534-1.565-1.271-1.806-3.573-0.534-5.137 1.271-1.568 3.574-1.805 5.139-0.534z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m360.6 375.55c1.569 1.272 1.806 3.573 0.534 5.137-1.272 1.568-3.574 1.805-5.139 0.534-1.569-1.271-1.806-3.573-0.534-5.137 1.272-1.568 3.574-1.805 5.139-0.534z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m306.17 365.07c1.306 1.06 1.506 2.976 0.445 4.281-1.06 1.305-2.977 1.505-4.282 0.445-1.306-1.06-1.506-2.976-0.445-4.281 1.06-1.305 2.977-1.505 4.282-0.445z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m290.81 323.58c1.305 1.06 1.506 2.976 0.445 4.281-1.06 1.305-2.977 1.505-4.283 0.445-1.305-1.06-1.505-2.976-0.445-4.281 1.061-1.305 2.978-1.505 4.283-0.445z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m292.43 354.98c1.071 0.871 1.235 2.442 0.363 3.513-0.871 1.071-2.443 1.234-3.515 0.363s-1.235-2.442-0.363-3.513c0.871-1.071 2.443-1.234 3.515-0.363z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m378.89 336.1c0.675 0.549 0.779 1.538 0.23 2.213-0.548 0.674-1.538 0.778-2.213 0.23-0.675-0.549-0.779-1.538-0.23-2.213 0.549-0.674 1.539-0.778 2.213-0.23z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m377.18 356.7c1.346 1.094 1.553 3.073 0.46 4.418-1.094 1.346-3.074 1.553-4.42 0.46-1.346-1.094-1.554-3.073-0.46-4.418s3.074-1.553 4.42-0.46z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m305.99 405.59c1.183 0.96 1.365 2.699 0.404 3.881-0.96 1.182-2.699 1.364-3.882 0.404s-1.364-2.698-0.404-3.881c0.96-1.182 2.699-1.363 3.882-0.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m347.78 404.69c0.792-1.485 0.23-3.33-1.256-4.122-1.485-0.791-3.331-0.229-4.123 1.255-0.792 1.485-0.23 3.33 1.256 4.122 1.485 0.791 3.331 0.229 4.123-1.255z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m385.2 399.88c1.405 1.138 1.62 3.203 0.478 4.604-1.138 1.404-3.204 1.619-4.605 0.478-1.406-1.138-1.621-3.203-0.479-4.603 1.139-1.405 3.204-1.62 4.606-0.479z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m278.95 345.72c1.379 1.119 1.587 3.139 0.471 4.518-1.12 1.379-3.141 1.586-4.52 0.471-1.38-1.116-1.587-3.14-0.471-4.518 1.12-1.379 3.14-1.587 4.52-0.471z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m263.17 251.32c1.131 0.915 1.302 2.576 0.386 3.706s-2.577 1.301-3.708 0.385c-1.131-0.915-1.301-2.575-0.386-3.706 0.916-1.13 2.577-1.301 3.708-0.385z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m274.68 281.85c1.193-0.384 1.848-1.663 1.463-2.855s-1.664-1.847-2.857-1.462-1.847 1.663-1.462 2.856c0.385 1.192 1.664 1.846 2.856 1.461z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m306.38 304.86c1.628 1.319 1.876 3.706 0.556 5.333s-3.708 1.875-5.336 0.556c-1.628-1.32-1.876-3.706-0.556-5.333s3.708-1.876 5.336-0.556z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m306.38 262.59c1.628 1.32 1.876 3.707 0.556 5.334s-3.708 1.875-5.336 0.556c-1.628-1.32-1.876-3.707-0.556-5.334s3.708-1.875 5.336-0.556z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m268.71 178.06c1.487 1.205 1.713 3.388 0.508 4.874s-3.389 1.712-4.876 0.508c-1.487-1.205-1.713-3.388-0.508-4.874s3.389-1.712 4.876-0.508z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m171.62 132.33c1.52 1.234 1.753 3.469 0.519 4.989-1.235 1.519-3.471 1.753-4.991 0.518-1.521-1.234-1.754-3.469-0.519-4.988 1.234-1.52 3.47-1.753 4.991-0.519z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m212.14 128.51c0.576-1.428-0.116-3.051-1.545-3.626-1.428-0.575-3.053 0.117-3.628 1.544-0.575 1.428 0.117 3.052 1.545 3.627 1.429 0.575 3.053-0.117 3.628-1.545z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m188.12 131.53c1.294 1.049 1.491 2.95 0.441 4.244-1.049 1.293-2.951 1.49-4.245 0.441s-1.491-2.95-0.442-4.244c1.05-1.293 2.952-1.49 4.246-0.441z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m210.32 247.22c1.102 0.893 1.269 2.505 0.375 3.606s-2.507 1.268-3.608 0.374c-1.101-0.893-1.268-2.505-0.374-3.606 0.893-1.1 2.506-1.267 3.607-0.374z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m222.81 223.34c1.101 0.893 1.268 2.505 0.374 3.606-0.893 1.101-2.506 1.267-3.607 0.374-1.102-0.893-1.269-2.505-0.375-3.606s2.507-1.268 3.608-0.374z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m179.62 171.12c1.331 1.083 1.535 3.036 0.453 4.366-1.083 1.331-3.037 1.535-4.368 0.452-1.332-1.082-1.536-3.035-0.453-4.366 1.083-1.33 3.037-1.534 4.368-0.452z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m364.73 162.6c1.079 0.878 1.246 2.465 0.367 3.543-0.879 1.079-2.466 1.245-3.545 0.367s-1.246-2.465-0.367-3.543c0.879-1.079 2.466-1.245 3.545-0.367z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m252.76 228.03c1.079 0.879 1.246 2.465 0.367 3.544-0.879 1.078-2.466 1.245-3.545 0.367-1.079-0.879-1.245-2.465-0.367-3.544 0.879-1.078 2.466-1.245 3.545-0.367z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m174.53 217.82c1.673 1.356 1.925 3.81 0.571 5.478-1.357 1.671-3.811 1.923-5.48 0.571-1.672-1.357-1.925-3.81-0.571-5.478 1.357-1.672 3.812-1.924 5.48-0.571z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m281.25 229.42c0.86 0.7 0.993 1.964 0.293 2.824-0.701 0.86-1.966 0.993-2.826 0.293-0.86-0.701-0.994-1.964-0.293-2.824s1.965-0.994 2.826-0.293z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m266.66 203.09c1.368 1.109 1.576 3.114 0.467 4.481-1.109 1.368-3.115 1.575-4.483 0.467s-1.576-3.113-0.467-4.481c1.108-1.367 3.115-1.575 4.483-0.467z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m221.14 331.65c0.894 0.727 1.031 2.035 0.304 2.928s-2.036 1.03-2.929 0.304c-0.894-0.726-1.031-2.035-0.304-2.928 0.726-0.893 2.035-1.03 2.929-0.304z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m248.53 359.97c0.893 0.727 1.03 2.035 0.304 2.928-0.727 0.893-2.036 1.03-2.93 0.304-0.893-0.726-1.031-2.035-0.304-2.928s2.036-1.03 2.93-0.304z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m192.43 270.94c0.894 0.726 1.031 2.035 0.304 2.928s-2.036 1.03-2.929 0.304c-0.894-0.727-1.031-2.035-0.304-2.928s2.036-1.03 2.929-0.304z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m378.01 375.7c2.11-0.073 3.761-1.842 3.687-3.951-0.073-2.109-1.843-3.76-3.953-3.686-2.11 0.073-3.761 1.842-3.688 3.951 0.074 2.109 1.843 3.76 3.954 3.686z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m276.86 371.04c1.053 0.852 1.213 2.398 0.36 3.45-0.853 1.053-2.399 1.212-3.452 0.36-1.054-0.853-1.213-2.398-0.36-3.451 0.853-1.052 2.399-1.212 3.452-0.359z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m291.17 374.3c1.053 0.852 1.213 2.398 0.36 3.45-0.853 1.053-2.399 1.212-3.452 0.36-1.053-0.853-1.213-2.398-0.36-3.451 0.853-1.052 2.399-1.212 3.452-0.359z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m412.06 210.3c1.524 1.238 1.758 3.472 0.519 4.996-1.238 1.523-3.474 1.756-4.998 0.519-1.524-1.238-1.758-3.473-0.519-4.996 1.238-1.524 3.474-1.757 4.998-0.519z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m413.9 246.51c1.524 1.238 1.758 3.473 0.519 4.996-1.238 1.523-3.474 1.757-4.998 0.519s-1.758-3.473-0.519-4.996c1.238-1.523 3.474-1.757 4.998-0.519z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m390.5 272.5c1.642 1.33 1.891 3.743 0.559 5.381-1.331 1.642-3.745 1.89-5.384 0.56-1.642-1.331-1.891-3.744-0.559-5.382 1.331-1.642 3.745-1.89 5.384-0.559z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m164.5 255.7c1.268 1.026 1.461 2.887 0.43 4.154-1.027 1.268-2.889 1.461-4.157 0.43-1.268-1.026-1.461-2.887-0.43-4.154 1.027-1.268 2.889-1.461 4.157-0.43z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m420.2 222.19c1.349 1.097 1.557 3.08 0.46 4.433-1.098 1.349-3.082 1.557-4.435 0.46-1.35-1.097-1.558-3.08-0.46-4.433 1.098-1.349 3.081-1.557 4.435-0.46z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m436.36 233.92c0.942 0.763 1.083 2.146 0.319 3.084-0.764 0.941-2.147 1.082-3.085 0.318-0.942-0.763-1.083-2.146-0.319-3.083 0.764-0.942 2.147-1.082 3.085-0.319z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m405.62 178.2c1.409 1.141 1.624 3.209 0.478 4.618-1.142 1.408-3.211 1.623-4.62 0.482-1.409-1.142-1.624-3.21-0.478-4.618 1.142-1.409 3.211-1.624 4.62-0.478v-4e-3z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m382.35 220.41c1.261 1.023 1.453 2.876 0.43 4.136s-2.877 1.453-4.138 0.43-1.454-2.876-0.43-4.136c1.023-1.26 2.877-1.453 4.138-0.43z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m246.73 85.262c1.038 0.8413 1.194 2.3645 0.352 3.4023-0.841 1.0377-2.365 1.1934-3.404 0.3521-1.038-0.8413-1.194-2.3646-0.352-3.4024 0.842-1.0377 2.366-1.1934 3.404-0.352z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m176.32 244.84c1.038 0.841 1.194 2.364 0.352 3.402s-2.366 1.193-3.404 0.352-1.194-2.365-0.352-3.402c0.842-1.038 2.366-1.194 3.404-0.352z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m168.48 159.65c1.038 0.842 1.194 2.365 0.352 3.403-0.841 1.038-2.365 1.193-3.404 0.352-1.038-0.841-1.194-2.365-0.352-3.402 0.842-1.038 2.366-1.194 3.404-0.353z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m198.24 251.5c1.465 1.189 1.691 3.339 0.501 4.803s-3.341 1.69-4.806 0.5c-1.464-1.189-1.691-3.339-0.5-4.803 1.19-1.464 3.341-1.69 4.805-0.5z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m189.44 154.52c1.241-1.646 0.912-3.986-0.736-5.226-1.647-1.24-3.988-0.911-5.229 0.735-1.24 1.647-0.911 3.987 0.736 5.227s3.989 0.911 5.229-0.736z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m191.6 215.26c0.886 0.719 1.019 2.02 0.3 2.906s-2.021 1.019-2.907 0.3-1.02-2.02-0.3-2.906c0.719-0.885 2.021-1.019 2.907-0.3z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m199.34 195c0.886 0.719 1.02 2.02 0.3 2.906-0.719 0.886-2.021 1.019-2.907 0.3s-1.02-2.02-0.3-2.905c0.719-0.886 2.021-1.02 2.907-0.301z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m209.6 144.7c1.28 1.038 1.472 2.913 0.434 4.188-1.038 1.279-2.914 1.472-4.19 0.434-1.275-1.038-1.472-2.913-0.434-4.188 1.039-1.275 2.915-1.472 4.19-0.434z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m231.96 250.38c1.279 1.038 1.472 2.914 0.434 4.189-1.038 1.274-2.915 1.471-4.19 0.433-1.279-1.038-1.472-2.913-0.434-4.188 1.038-1.279 2.914-1.471 4.19-0.434z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m266 90.566c1.279 1.0377 1.472 2.9131 0.433 4.188-1.038 1.2787-2.914 1.4714-4.19 0.4337-1.279-1.0378-1.472-2.9132-0.433-4.1881 1.038-1.2787 2.914-1.4714 4.19-0.4336z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m238.59 373.52c1.206 0.979 1.391 2.75 0.412 3.959-0.979 1.204-2.751 1.389-3.96 0.411-1.205-0.978-1.391-2.75-0.412-3.958 0.979-1.205 2.752-1.39 3.96-0.412z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m257.79 347.33c1.317 1.067 1.517 2.998 0.449 4.314-1.068 1.315-3 1.515-4.316 0.448-1.317-1.067-1.517-2.998-0.449-4.314s3-1.516 4.316-0.448z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m261.8 268.54c0.916 0.742 1.056 2.087 0.311 3.002-0.741 0.916-2.087 1.057-3.003 0.312-0.916-0.742-1.057-2.087-0.312-3.002 0.742-0.916 2.088-1.057 3.004-0.312z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m327.16 333.89c2.159-0.247 3.708-2.197 3.461-4.354-0.248-2.158-2.198-3.706-4.357-3.459-2.158 0.247-3.708 2.197-3.46 4.355 0.247 2.157 2.198 3.706 4.356 3.458z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m306.32 426.09c1.532 1.245 1.769 3.495 0.523 5.026-1.246 1.53-3.496 1.768-5.028 0.522-1.531-1.245-1.768-3.495-0.523-5.025 1.246-1.531 3.497-1.768 5.028-0.523z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m345.36 377.39c0.949 0.771 1.094 2.164 0.323 3.113-0.772 0.949-2.166 1.093-3.115 0.323-0.949-0.771-1.094-2.165-0.323-3.114 0.771-0.948 2.166-1.093 3.115-0.322z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m327.32 392.26c1.627 1.32 1.876 3.71 0.556 5.337s-3.712 1.876-5.34 0.556c-1.627-1.319-1.876-3.71-0.556-5.337s3.712-1.875 5.34-0.556z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m305.44 385.84c0.99 0.804 1.142 2.257 0.338 3.247-0.805 0.989-2.258 1.141-3.248 0.337s-1.142-2.257-0.338-3.247c0.805-0.989 2.258-1.141 3.248-0.337z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m355.21 348.71c1.344-1.696 1.058-4.16-0.638-5.503-1.697-1.344-4.162-1.059-5.506 0.637s-1.059 4.16 0.638 5.504c1.697 1.343 4.162 1.058 5.506-0.638z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m262.77 329.83c1.453 1.178 1.676 3.313 0.497 4.766-1.18 1.453-3.315 1.675-4.769 0.496-1.453-1.178-1.676-3.313-0.497-4.766s3.315-1.675 4.769-0.496z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m271.41 405.1c1.453 1.179 1.676 3.314 0.497 4.766-1.179 1.453-3.315 1.676-4.769 0.497-1.453-1.178-1.676-3.313-0.497-4.766s3.315-1.675 4.769-0.497z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m257.45 392.64c1.453 1.178 1.676 3.313 0.497 4.766-1.18 1.453-3.315 1.675-4.769 0.497-1.453-1.179-1.676-3.314-0.497-4.767 1.179-1.452 3.315-1.675 4.769-0.496z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m285.77 392.27c1.027 0.834 1.183 2.342 0.349 3.369-0.835 1.026-2.344 1.182-3.371 0.348s-1.183-2.342-0.349-3.369c0.835-1.026 2.344-1.182 3.371-0.348z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m266.26 377.02c1.454 1.179 1.676 3.314 0.497 4.767-1.179 1.452-3.315 1.675-4.769 0.496-1.453-1.178-1.676-3.313-0.496-4.766 1.179-1.453 3.315-1.675 4.768-0.497z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m392.28 324.49c1.046 0.848 1.205 2.386 0.356 3.432-0.849 1.045-2.388 1.204-3.434 0.355-1.045-0.848-1.205-2.386-0.356-3.432 0.85-1.045 2.388-1.204 3.434-0.355z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m380.88 129.92c0.99 0.804 1.142 2.257 0.338 3.243-0.805 0.99-2.259 1.142-3.245 0.337-0.99-0.804-1.142-2.257-0.337-3.243 0.804-0.989 2.258-1.141 3.244-0.337z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m345.53 255.71c1.064 0.864 1.227 2.428 0.363 3.491-0.864 1.064-2.429 1.227-3.493 0.363-1.064-0.863-1.227-2.427-0.363-3.491s2.428-1.227 3.493-0.363z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m328.46 362.85c1.179 0.956 1.361 2.691 0.4 3.869-0.956 1.179-2.692 1.36-3.871 0.401-1.179-0.957-1.361-2.691-0.4-3.87 0.96-1.178 2.692-1.36 3.871-0.4z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m326.8 419.4c1.9-0.019 3.425-1.574 3.406-3.474-0.019-1.899-1.575-3.424-3.476-3.404-1.9 0.019-3.425 1.574-3.406 3.474 0.02 1.899 1.576 3.423 3.476 3.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m184.17 194.4c1.22 0.989 1.409 2.783 0.415 4.002-0.99 1.22-2.785 1.409-4.005 0.415-1.22-0.989-1.409-2.783-0.415-4.002 0.99-1.22 2.785-1.409 4.005-0.415z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m180.63 264.13c1.117 0.904 1.287 2.546 0.382 3.661-0.904 1.116-2.547 1.286-3.663 0.382s-1.287-2.546-0.382-3.662c0.905-1.115 2.547-1.286 3.663-0.381z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m152.37 241.96c1.116 0.904 1.286 2.546 0.382 3.662-0.905 1.115-2.548 1.286-3.664 0.381-1.116-0.904-1.287-2.546-0.382-3.661 0.905-1.116 2.548-1.286 3.664-0.382z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m409.17 318.63c1.142 0.927 1.316 2.602 0.389 3.74-0.927 1.141-2.603 1.316-3.741 0.389-1.143-0.926-1.317-2.602-0.39-3.74 0.927-1.141 2.603-1.315 3.742-0.389z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m293.7 207.05c1.402 1.134 1.613 3.191 0.479 4.592-1.135 1.401-3.193 1.612-4.594 0.478-1.402-1.134-1.613-3.191-0.479-4.592 1.135-1.401 3.193-1.612 4.594-0.478z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m243.47 208.89c0.971 0.789 1.119 2.213 0.33 3.184-0.79 0.971-2.214 1.119-3.186 0.329-0.971-0.789-1.119-2.212-0.33-3.187 0.79-0.971 2.214-1.119 3.186-0.33v4e-3z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m169.9 191.27c1.108 0.901 1.279 2.528 0.378 3.636s-2.529 1.279-3.638 0.378c-1.108-0.901-1.279-2.528-0.378-3.636s2.529-1.278 3.638-0.378z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m288.18 299.56c1.506 1.223 1.735 3.432 0.512 4.941-1.224 1.505-3.434 1.734-4.943 0.511-1.505-1.223-1.735-3.432-0.512-4.94 1.224-1.505 3.434-1.735 4.943-0.512z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m193.65 233.34c1.079 0.874 1.242 2.457 0.367 3.535-0.875 1.079-2.458 1.242-3.537 0.367-1.079-0.874-1.242-2.457-0.367-3.535 0.875-1.079 2.458-1.242 3.537-0.367z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m426.06 250.57c1.407-1e-3 2.547-1.143 2.545-2.549-1e-3 -1.406-1.143-2.545-2.55-2.543-1.407 1e-3 -2.546 1.142-2.545 2.549 2e-3 1.406 1.144 2.545 2.55 2.543z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m425.74 275.9c1.06 0.86 1.223 2.42 0.363 3.48s-2.421 1.223-3.482 0.363c-1.06-0.86-1.224-2.42-0.363-3.48 0.86-1.06 2.421-1.223 3.482-0.363z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m228.29 389.05c1.087 0.883 1.254 2.476 0.371 3.562-0.882 1.086-2.477 1.253-3.563 0.371-1.087-0.882-1.254-2.476-0.371-3.562 0.882-1.086 2.477-1.253 3.563-0.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m206.56 385.47c1.19 0.968 1.372 2.717 0.408 3.907-0.968 1.189-2.718 1.371-3.909 0.407-1.19-0.967-1.372-2.716-0.407-3.906 0.967-1.19 2.718-1.371 3.908-0.408z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m221.42 282.48c1.079 0.875 1.242 2.457 0.367 3.536-0.875 1.078-2.459 1.241-3.538 0.367-1.079-0.875-1.242-2.458-0.367-3.536 0.875-1.079 2.459-1.242 3.538-0.367z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m267.72 295.68c0.861 0.701 0.994 1.964 0.293 2.824-0.7 0.86-1.965 0.994-2.825 0.293-0.86-0.7-0.994-1.964-0.293-2.824s1.965-0.993 2.825-0.293z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m194.46 288.7c0.86 0.701 0.994 1.965 0.293 2.824-0.701 0.86-1.966 0.994-2.826 0.293-0.86-0.7-0.994-1.964-0.293-2.824s1.966-0.993 2.826-0.293z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m231.73 301.1c1.209 0.983 1.395 2.758 0.412 3.97s-2.759 1.393-3.971 0.411c-1.209-0.982-1.395-2.757-0.412-3.969 0.983-1.208 2.759-1.394 3.971-0.412z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m201.65 327.13c1.724-0.424 2.778-2.164 2.354-3.887-0.424-1.724-2.166-2.777-3.89-2.353s-2.778 2.164-2.354 3.888c0.424 1.723 2.166 2.776 3.89 2.352z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m224.14 356.65c1.38 1.12 1.587 3.14 0.471 4.518-1.12 1.379-3.14 1.587-4.52 0.471-1.379-1.119-1.587-3.139-0.471-4.518 1.12-1.379 3.141-1.586 4.52-0.471z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m285.57 415.55c1.172 0.949 1.35 2.669 0.401 3.84-0.95 1.171-2.67 1.349-3.842 0.4-1.172-0.948-1.35-2.668-0.4-3.839 0.949-1.171 2.669-1.349 3.841-0.401z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m208.42 309.74c1.268 1.027 1.461 2.887 0.43 4.155-1.027 1.267-2.889 1.46-4.157 0.43-1.268-1.027-1.461-2.888-0.43-4.155 1.027-1.268 2.889-1.46 4.157-0.43z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m238.67 344.58c1.268 1.027 1.461 2.887 0.43 4.155-1.027 1.267-2.889 1.46-4.157 0.429-1.268-1.03-1.461-2.887-0.43-4.154 1.027-1.268 2.889-1.46 4.157-0.43z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m197.06 308.12c1.157 0.938 1.331 2.635 0.393 3.792-0.938 1.156-2.636 1.33-3.793 0.392-1.157-0.937-1.331-2.635-0.393-3.791s2.636-1.331 3.793-0.393z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m246.98 279.93c1.205 0.979 1.391 2.75 0.412 3.958-0.979 1.205-2.752 1.39-3.96 0.412-1.205-0.979-1.391-2.75-0.412-3.959 0.979-1.204 2.751-1.389 3.96-0.411z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m222.18 318.23c1.316 1.068 1.516 2.999 0.448 4.315-1.067 1.315-2.999 1.515-4.316 0.448-1.316-1.067-1.516-2.998-0.448-4.314s2.999-1.516 4.316-0.449z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m250.87 308.16c1.317 1.068 1.517 2.999 0.449 4.315-1.068 1.315-3 1.515-4.316 0.448s-1.517-2.998-0.449-4.314 3-1.516 4.316-0.449z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m207.31 284.55c1.116 0.905 1.286 2.546 0.382 3.662-0.905 1.116-2.548 1.286-3.664 0.382-1.116-0.905-1.286-2.546-0.382-3.662 0.905-1.116 2.548-1.286 3.664-0.382z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m212.47 338c1.209 0.982 1.394 2.757 0.412 3.969-0.983 1.212-2.759 1.394-3.971 0.412-1.209-0.982-1.395-2.758-0.412-3.97s2.759-1.393 3.971-0.411z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m408.01 227.13c1.665 1.349 1.917 3.792 0.567 5.456s-3.793 1.916-5.458 0.567-1.917-3.791-0.567-5.456c1.349-1.664 3.793-1.916 5.458-0.567z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m421.9 291.37c1.524 1.238 1.757 3.473 0.519 4.996-1.239 1.524-3.475 1.757-4.999 0.519s-1.757-3.473-0.519-4.996c1.239-1.523 3.475-1.757 4.999-0.519z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m423.74 192.77c1.524 1.237 1.758 3.472 0.519 4.996-1.238 1.523-3.474 1.756-4.998 0.518-1.524-1.237-1.758-3.472-0.519-4.996 1.238-1.523 3.474-1.756 4.998-0.518z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m344.98 219.94c1.524 1.238 1.758 3.473 0.519 4.996-1.238 1.524-3.474 1.757-4.998 0.519s-1.758-3.473-0.519-4.996c1.238-1.523 3.474-1.757 4.998-0.519z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m360.2 283.02c1.302 1.056 1.498 2.961 0.441 4.262-1.056 1.301-2.962 1.497-4.264 0.441-1.301-1.056-1.498-2.961-0.441-4.262s2.963-1.498 4.264-0.441z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m323.38 248.37c1.642 1.33 1.891 3.743 0.559 5.381-1.331 1.642-3.745 1.89-5.384 0.56-1.642-1.331-1.891-3.744-0.559-5.382 1.331-1.642 3.745-1.89 5.384-0.559z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m284.4 253.31c0.927 0.752 1.068 2.113 0.315 3.039-0.753 0.927-2.114 1.068-3.041 0.315-0.927-0.752-1.068-2.112-0.315-3.039 0.753-0.926 2.114-1.067 3.037-0.315h4e-3z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m306.2 326.16c1.584 1.282 1.825 3.606 0.538 5.189-1.283 1.582-3.608 1.823-5.191 0.537-1.583-1.282-1.825-3.606-0.538-5.189 1.283-1.582 3.608-1.823 5.191-0.537z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m290.51 150.16c1.561 1.268 1.802 3.562 0.534 5.122-1.268 1.561-3.563 1.802-5.124 0.534-1.561-1.267-1.802-3.562-0.534-5.122s3.563-1.801 5.124-0.534z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m305.43 189.48c0.983 0.797 1.135 2.242 0.334 3.228-0.797 0.982-2.243 1.134-3.23 0.333-0.982-0.796-1.134-2.242-0.333-3.228 0.797-0.982 2.243-1.134 3.229-0.333z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m305.6 160.76c1.068 0.867 1.231 2.431 0.364 3.498-0.868 1.068-2.433 1.231-3.501 0.363-1.067-0.867-1.231-2.431-0.363-3.498 0.868-1.068 2.433-1.231 3.5-0.363z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m319.98 179.02c1.15 0.931 1.324 2.617 0.393 3.762-0.931 1.149-2.618 1.323-3.763 0.393-1.15-0.93-1.324-2.617-0.394-3.762 0.931-1.149 2.618-1.323 3.764-0.393z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m340.01 181.8c1.502 1.22 1.728 3.421 0.512 4.922s-3.423 1.727-4.924 0.512c-1.502-1.22-1.728-3.421-0.512-4.922 1.22-1.501 3.423-1.727 4.924-0.512z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m355.55 199.24c1.305 1.06 1.505 2.976 0.445 4.285-1.061 1.304-2.978 1.504-4.287 0.444-1.305-1.06-1.505-2.976-0.445-4.284 1.061-1.305 2.978-1.505 4.287-0.445z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m371.58 256.68c8e-3 -2.016-1.622-3.656-3.639-3.663s-3.658 1.622-3.665 3.638 1.622 3.656 3.639 3.663 3.658-1.621 3.665-3.638z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m294.51 268.96c1.131 0.919 1.302 2.576 0.386 3.706-0.919 1.131-2.577 1.301-3.708 0.386-1.131-0.919-1.301-2.576-0.386-3.707 0.92-1.13 2.578-1.3 3.708-0.385z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m305.65 241.99c1.131 0.92 1.302 2.576 0.386 3.707-0.92 1.13-2.577 1.301-3.708 0.385-1.131-0.919-1.301-2.576-0.386-3.706 0.92-1.13 2.577-1.301 3.708-0.386z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m381.88 175.57c0.942 0.764 1.083 2.146 0.319 3.084-0.764 0.941-2.147 1.082-3.085 0.319-0.942-0.764-1.083-2.146-0.319-3.084 0.764-0.941 2.147-1.082 3.085-0.319z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m429.37 210.49c0.942 0.763 1.083 2.146 0.319 3.083-0.764 0.942-2.147 1.083-3.085 0.319-0.942-0.763-1.083-2.146-0.319-3.084 0.764-0.941 2.147-1.082 3.085-0.318z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m352.82 114.05c1.186 0.964 1.368 2.702 0.404 3.888s-2.703 1.368-3.89 0.404c-1.186-0.963-1.368-2.702-0.404-3.888s2.703-1.367 3.89-0.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m407.31 135.29c1.186 0.963 1.368 2.701 0.404 3.887s-2.703 1.368-3.89 0.404c-1.186-0.963-1.368-2.701-0.404-3.887s2.703-1.368 3.89-0.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m467.66 167.53c1.019 0.827 1.175 2.328 0.348 3.347s-2.329 1.175-3.348 0.348c-1.02-0.826-1.176-2.327-0.349-3.346 0.831-1.02 2.329-1.175 3.349-0.349z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m390.9 313.81c1.187 0.964 1.368 2.702 0.404 3.888s-2.703 1.368-3.889 0.404c-1.187-0.964-1.369-2.702-0.404-3.888 0.964-1.186 2.703-1.367 3.889-0.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m406.77 154.72c1.187 0.963 1.369 2.702 0.404 3.888-0.964 1.186-2.703 1.367-3.889 0.404-1.187-0.964-1.368-2.702-0.404-3.888s2.703-1.368 3.889-0.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m434.76 141.23c1.187 0.963 1.368 2.702 0.404 3.888s-2.703 1.367-3.89 0.404c-1.186-0.964-1.368-2.702-0.404-3.888s2.703-1.368 3.89-0.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m442.36 182.46c1.187 0.963 1.369 2.701 0.404 3.887-0.964 1.186-2.703 1.368-3.889 0.404-1.187-0.963-1.369-2.701-0.404-3.887 0.964-1.186 2.703-1.368 3.889-0.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m440.78 150.11c1.186 0.964 1.368 2.702 0.404 3.888s-2.703 1.368-3.89 0.404c-1.186-0.963-1.368-2.702-0.404-3.888s2.703-1.367 3.89-0.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m389.15 140.17c1.186 0.964 1.368 2.702 0.404 3.888s-2.703 1.368-3.89 0.404c-1.186-0.963-1.368-2.702-0.404-3.888s2.703-1.367 3.89-0.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m440.58 132.94c1.186 0.963 1.368 2.702 0.404 3.888s-2.703 1.367-3.89 0.404c-1.187-0.964-1.368-2.702-0.404-3.888s2.703-1.368 3.89-0.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m394.2 123.06c1.186 0.964 1.368 2.702 0.404 3.888s-2.703 1.368-3.89 0.404c-1.186-0.964-1.368-2.702-0.404-3.888s2.703-1.367 3.89-0.404z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m353.51 144.17c1.049 0.852 1.212 2.394 0.359 3.446-0.853 1.049-2.395 1.212-3.448 0.36-1.05-0.852-1.213-2.394-0.36-3.447 0.853-1.049 2.395-1.212 3.449-0.359z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m369.44 140.1c1.049 0.852 1.212 2.394 0.359 3.447-0.853 1.049-2.395 1.212-3.448 0.359-1.049-0.852-1.213-2.394-0.36-3.447 0.853-1.048 2.396-1.212 3.449-0.359z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m333.38 95.744c1.657 1.3454 1.909 3.7767 0.563 5.4334-1.346 1.657-3.778 1.909-5.436 0.563-1.657-1.345-1.909-3.7764-0.563-5.4331s3.778-1.9087 5.436-0.5633z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m360.22 134.58c2.122-0.224 3.66-2.126 3.436-4.247-0.225-2.121-2.127-3.658-4.249-3.434-2.122 0.225-3.66 2.126-3.436 4.247 0.225 2.121 2.127 3.658 4.249 3.434z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m421.9 156.1c2.123-0.221 3.665-2.119 3.444-4.24-0.22-2.122-2.119-3.663-4.242-3.443-2.122 0.221-3.664 2.119-3.444 4.241 0.221 2.121 2.12 3.662 4.242 3.442z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m454.26 156.57c1.172 0.949 1.35 2.668 0.4 3.84-0.949 1.171-2.669 1.349-3.841 0.4s-1.35-2.669-0.401-3.84c0.95-1.171 2.67-1.349 3.842-0.4z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m444.02 166.95c1.342 1.09 1.546 3.058 0.456 4.396-1.09 1.341-3.059 1.545-4.398 0.455-1.342-1.089-1.546-3.057-0.456-4.395 1.09-1.342 3.059-1.546 4.398-0.456z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m317.18 122.76c1.046 0.849 1.206 2.379 0.356 3.425-0.849 1.045-2.38 1.204-3.426 0.355-1.045-0.848-1.205-2.379-0.356-3.424s2.381-1.205 3.426-0.356z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m324.37 204.07c1.261 1.023 1.453 2.876 0.43 4.136s-2.877 1.453-4.138 0.43-1.454-2.876-0.43-4.136c1.023-1.26 2.877-1.453 4.138-0.43z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m409.16 268.59c1.58 1.282 1.821 3.599 0.538 5.178-1.283 1.578-3.601 1.819-5.177 0.537-1.579-1.282-1.82-3.599-0.537-5.178 1.283-1.578 3.6-1.819 5.18-0.537h-4e-3z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m361.88 324.21c1.58 1.282 1.821 3.598 0.538 5.177s-3.601 1.82-5.177 0.538c-1.579-1.283-1.82-3.599-0.537-5.178s3.6-1.82 5.176-0.537z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m329.28 271.6c1.094 0.886 1.261 2.491 0.371 3.581-0.886 1.093-2.492 1.26-3.582 0.37-1.094-0.886-1.261-2.49-0.371-3.58 0.886-1.093 2.492-1.26 3.582-0.371z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m322.64 297.99c1.138 0.923 1.313 2.591 0.389 3.729-0.923 1.137-2.592 1.312-3.73 0.389s-1.313-2.591-0.389-3.729c0.923-1.138 2.592-1.312 3.73-0.389z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m432.16 258.78c1.591 1.29 1.835 3.628 0.541 5.218-1.29 1.59-3.63 1.835-5.22 0.541-1.591-1.293-1.836-3.628-0.542-5.218 1.291-1.59 3.63-1.835 5.221-0.541z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m306.04 218.68c1.394 1.131 1.605 3.176 0.474 4.566s-3.177 1.605-4.568 0.475c-1.394-1.131-1.605-3.177-0.474-4.566 1.13-1.394 3.177-1.605 4.568-0.475z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m306.3 134.26c1.58 1.279 1.821 3.595 0.538 5.174-1.279 1.579-3.597 1.82-5.176 0.538-1.58-1.279-1.821-3.596-0.538-5.174 1.279-1.579 3.597-1.82 5.176-0.538z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m275.41 137.93c1.58 1.278 1.821 3.595 0.538 5.174-1.279 1.579-3.597 1.82-5.176 0.537-1.58-1.278-1.821-3.595-0.538-5.174 1.279-1.579 3.597-1.82 5.176-0.537z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m247.31 130.66c1.58 1.278 1.821 3.595 0.538 5.174-1.279 1.579-3.597 1.819-5.176 0.537-1.58-1.279-1.821-3.595-0.538-5.174 1.279-1.579 3.597-1.82 5.176-0.537z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m231.44 136.36c1.58 1.279 1.821 3.595 0.538 5.174-1.28 1.579-3.597 1.82-5.177 0.538-1.579-1.279-1.82-3.595-0.537-5.174 1.279-1.579 3.596-1.82 5.176-0.538z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m305.99 102.99c1.439 1.167 1.658 3.276 0.49 4.714s-3.278 1.657-4.717 0.489c-1.439-1.167-1.657-3.276-0.489-4.714s3.278-1.657 4.716-0.489z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m318.87 140.5c1.005 0.816 1.157 2.291 0.341 3.295-0.815 1.004-2.291 1.156-3.296 0.341s-1.157-2.29-0.341-3.295c0.816-1.004 2.291-1.156 3.296-0.341z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m269.15 120.8c1.005 0.815 1.157 2.29 0.341 3.295-0.816 1.004-2.292 1.156-3.297 0.341-1.004-0.816-1.156-2.291-0.341-3.295 0.816-1.005 2.292-1.157 3.297-0.341z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m344.02 102.32c1.005 0.816 1.157 2.291 0.341 3.295-0.816 1.005-2.292 1.157-3.296 0.341-1.005-0.815-1.157-2.29-0.342-3.295 0.816-1.004 2.292-1.156 3.297-0.341z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m371.58 114.38c1.005 0.815 1.157 2.29 0.341 3.294-0.815 1.005-2.291 1.157-3.296 0.341-1.005-0.815-1.157-2.29-0.341-3.294 0.816-1.005 2.291-1.157 3.296-0.341z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m333.11 115.75c1.475 1.197 1.702 3.361 0.504 4.837-1.198 1.475-3.363 1.701-4.839 0.504-1.476-1.198-1.702-3.362-0.504-4.837 1.197-1.475 3.363-1.701 4.839-0.504z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m245.8 149.56c1.487 1.204 1.713 3.387 0.508 4.87-1.205 1.486-3.389 1.712-4.873 0.507-1.486-1.204-1.713-3.387-0.508-4.87 1.206-1.482 3.39-1.712 4.873-0.507z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m189.13 179.48c1.561 1.267 1.802 3.562 0.534 5.122s-3.564 1.801-5.125 0.534c-1.561-1.268-1.802-3.562-0.534-5.122 1.269-1.561 3.564-1.802 5.125-0.534z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m204.56 163.58c1.58 1.279 1.821 3.595 0.538 5.174-1.279 1.579-3.597 1.82-5.177 0.537-1.579-1.278-1.82-3.595-0.537-5.174 1.279-1.578 3.597-1.819 5.176-0.537z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m259.5 105.72c1.005 0.815 1.157 2.291 0.341 3.295-0.815 1.004-2.291 1.156-3.296 0.341-1.005-0.816-1.157-2.291-0.341-3.295s2.291-1.156 3.296-0.341z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m218.85 132.05c1.005 0.815 1.157 2.29 0.341 3.295-0.816 1.004-2.292 1.156-3.297 0.341-1.004-0.816-1.157-2.291-0.341-3.295 0.816-1.005 2.292-1.157 3.297-0.341z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m264.09 115.27c1.005 0.815 1.157 2.29 0.341 3.295-0.816 1.004-2.292 1.156-3.297 0.341-1.004-0.816-1.156-2.291-0.341-3.295 0.816-1.005 2.292-1.157 3.297-0.341z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m278.4 96.4c1.005 0.8154 1.157 2.2905 0.341 3.2949-0.815 1.0046-2.291 1.1566-3.296 0.3406-1.005-0.815-1.157-2.2901-0.341-3.2945s2.291-1.1563 3.296-0.341z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m254.94 166.62c1.005 0.815 1.157 2.29 0.341 3.295-0.816 1.004-2.292 1.156-3.297 0.341-1.004-0.816-1.156-2.291-0.341-3.295 0.816-1.005 2.292-1.157 3.297-0.341z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m288.81 111.3c1.476 1.197 1.702 3.361 0.505 4.836-1.198 1.475-3.363 1.701-4.839 0.504s-1.702-3.361-0.504-4.836c1.197-1.475 3.363-1.702 4.838-0.504z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m224.36 194.27c1.476 1.197 1.702 3.362 0.504 4.837-1.197 1.475-3.363 1.701-4.839 0.504-1.475-1.197-1.702-3.362-0.504-4.837s3.363-1.701 4.839-0.504z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m306.42 82.686c1.475 1.1971 1.701 3.3616 0.504 4.8367-1.198 1.4751-3.363 1.7011-4.839 0.504s-1.702-3.3615-0.504-4.8366c1.197-1.4751 3.363-1.7012 4.839-0.5041z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m293.04 177.76c1.487 1.205 1.713 3.388 0.508 4.87-1.205 1.487-3.389 1.713-4.872 0.508-1.487-1.204-1.713-3.387-0.508-4.87 1.205-1.486 3.389-1.712 4.872-0.508z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m238.9 114.4c1.487 1.205 1.713 3.388 0.508 4.87-1.205 1.487-3.389 1.713-4.873 0.508-1.487-1.204-1.713-3.387-0.508-4.87 1.205-1.486 3.389-1.712 4.873-0.508z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m226 175.12c1.763-0.741 2.59-2.771 1.848-4.533s-2.773-2.589-4.536-1.847c-1.762 0.741-2.59 2.771-1.848 4.533s2.773 2.589 4.536 1.847z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m330.9 152.26c1.464 1.189 1.691 3.343 0.5 4.807-1.19 1.464-3.344 1.69-4.809 0.5s-1.691-3.343-0.5-4.807c1.19-1.464 3.344-1.69 4.809-0.5z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m440.98 210.93c1.459-1.274 1.608-3.489 0.334-4.947-1.275-1.459-3.491-1.608-4.95-0.334s-1.608 3.489-0.334 4.947c1.275 1.458 3.491 1.608 4.95 0.334z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m386.59 159.71c1.123 0.912 1.297 2.565 0.381 3.688-0.912 1.123-2.566 1.297-3.689 0.382-1.124-0.912-1.298-2.565-0.382-3.688 0.912-1.123 2.566-1.297 3.69-0.382z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m419.87 130.53c1.123 0.912 1.298 2.565 0.382 3.688-0.912 1.123-2.566 1.297-3.69 0.382-1.123-0.912-1.298-2.565-0.382-3.688 0.913-1.123 2.566-1.297 3.69-0.382z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m368.02 185.1c1.12 0.909 1.291 2.554 0.382 3.673-0.908 1.12-2.555 1.29-3.675 0.382-1.119-0.908-1.29-2.553-0.381-3.673 0.908-1.119 2.554-1.29 3.674-0.382z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m395 352.04c1.294-1.706 0.96-4.138-0.747-5.431-1.707-1.294-4.14-0.959-5.434 0.747s-0.96 4.138 0.747 5.431c1.707 1.294 4.14 0.959 5.434-0.747z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m320.68 220.38c0.864 0.701 0.998 1.972 0.297 2.839-0.701 0.864-1.973 0.997-2.841 0.297-0.864-0.701-0.997-1.972-0.296-2.839 0.701-0.864 1.972-0.997 2.84-0.297z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <path
          d="m384.55 194.06c1.409 1.142 1.624 3.21 0.478 4.615-1.142 1.408-3.211 1.623-4.616 0.478-1.409-1.142-1.624-3.21-0.479-4.615 1.143-1.408 3.212-1.623 4.617-0.478z"
          fill="var(--chart-302-icon-buttons-titles)"
          fill-opacity="0.8"
        />
        <g style="mix-blend-mode:multiply">
          <path
            d="m304.07 428.86-20.216-11.2-14.58-9.929-13.953-12.461 10.041-0.4 25.304 6.749 13.589 6.112-0.185 21.129z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m269.27 407.74-8.343-21.141-10.646-8.943-6.4-0.778-7.071-1.168 18.507 19.569 13.953 12.461z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m222.11 359.14 11.013 1.038-12.155-13.98-1.142-12.931-24.469-23.061 5.528 13.795 9.801 16.185 11.424 18.954z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m210.69 340.19v-18.29l-4.127-9.87-8.521-23.067-19.051-22.812 16.371 44.059"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m174.79 246.72-2.714-25.874-3.812-27.567-1.313-31.751 15.422 53.27v17.879l-7.583 14.043z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m172.08 220.84 10.297-24.238-4.717-23.076-8.276-38.448-2.429 26.444 1.313 31.751 3.812 27.567z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m304.25 407.74-11.488-14.043-13.838-16.041-14.802 1.998 20.134 14.476 19.994 13.61z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m284.26 394.13-8.94-21.177-19.463-23.242-35.616-29.094 16.571 26.266 10.405 14.71 16.908 18.061 20.135 14.476z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m236.81 346.88-1.131-26.848-5.728-16.741-10.123-18.858-23.739-30.283 9.578 32.418 14.572 34.046 16.571 26.266z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m205.67 286.57 3.037-37.359-18.407-32.348 1.769 18.431 4.023 18.858 9.578 32.418z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m303.88 105.59 0.107 31.522 0.041 25.581 13.364-20.374-1.751-17.664-11.761-19.065z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m304.03 162.69-0.041 28.567v29.943l8.492-25.436 4.913-53.448-13.405-5.207 0.041 25.581z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m303.99 191.26v116.54l13.405-41.198 3.578-15.263-1.561-29.39-15.422-30.692z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m303.99 265.54v42.262l-0.107 21.226 0.597 0.938 3.849-17.935 7.041-15.666-11.38-30.825z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m359.8 130.76 27.602 11.552 34.099 9.929-16.482 4.626-22.541-7.631-22.678-18.476z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m387.41 142.32 34.099 9.929v43.282l-3.293 29.113-8.387-11.579-6.278-32.307 1.476-23.883-17.617-14.555z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m421.51 195.53-3.293 29.113-6.552 24.628-4.824 22.178-7.601 24.917-10.082 19.591 10.082-42.877-1.528-22.564 6.748-20.377 5.37-17.075 11.68-17.534z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m186.84 182.31-0.382-30.05 21.261-5.241-12.877 14.736-8.002 20.555z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m440.62 184.61-1.94 23.713-3.704 27.3-6.986-23.427 12.63-27.586z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m438.68 208.32-3.704 27.3-5.154 26.037-5.643 16.163-4.513 16.311-12.173 26.559 4.171-37.76 14.417-34.938 12.599-39.672z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m407.49 320.69-15.581 29.016-14.008 22.148 12.755-36.662 0.089-8.809 28.919-32.252-12.174 26.559z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m439.04 152.26-0.204-17.174-20.624-2.513-25.752-7.361 13.104 12.223 27.45 5.942 6.026 8.883z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m370.1 116.2 22.356 9.01 25.752 7.361-12.648 4.862s-27.791-15.243-27.806-14.813-7.654-6.42-7.654-6.42z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m304.25 85.355-0.37 20.232-17.239 8.38-24.028 3.125 14.309-18.873 27.328-12.864z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m276.92 98.219v14.092l-9.252 10.307-15.106-4.196-15.845-1.33 21.307-9.555 4.586 9.555 14.31-18.873z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m236.72 117.09-27.176 10.362 31.852-1.075 16.631-18.842-21.307 9.555z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m304.25 407.74-0.264-20.107 0.264-20.199-14.625 8.777-25.503 3.443 20.134 14.476 19.994 13.61z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m303.88 329.03-14.254 47.181 14.361 11.422 0.264-20.199-0.371-38.404z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m303.88 105.59 27.061 12.835 28.863 12.342-27.962 1.805-27.855 4.54-0.107-31.522z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m330.94 118.42 28.863 12.346s27.676 10.781 27.602 11.552c-0.07 0.771-19.508-0.315-19.508-0.315l-19.474-0.593-17.48-22.99h-3e-3z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
        <g style="mix-blend-mode:multiply">
          <path
            d="m186.46 152.26 21.261-5.241 21.403-7.802-20.416 14.896-22.248-1.853z"
            fill="var(--chart-302-icon-buttons-titles)"
            fill-opacity=".05"
          />
        </g>
      </svg>
    `;
  }
}
